if (typeof pageIsWheelCollection === 'undefined') {
    window.pageIsWheelCollection = (function () { try { return wheelCollection; } catch (e) { return undefined; } })();
}
if (typeof pageIsPromo === 'undefined') {
    window.pageIsPromo = (function () { try { return isPromo; } catch (e) { return false; } })();
}

// Shared across every vuePLP() instance mounted on this page load (the
// main #PLP grid AND any number of bestseller "Top Selling Products"
// fallback carousels, which mount later, once the PLP grid finds itself
// empty - see GGbootstrap()'s mountBestsellers()). aiAgentPendingCollectionFilters
// is a one-shot localStorage key: the first instance to read it also
// removes it, so without this shared cache only that first instance ever
// saw it, and every instance mounted after (i.e. the bestseller fallback,
// which by construction always mounts second) silently missed the hand-off
// and fell back to hard-zeroing on its own vehicleFilters check instead.
//
// GGcollection.js is included via a <script src> tag in both
// GGcollectionGrid.liquid and GGbestsellerCollection.liquid, and both
// sections can render on the same page - so this whole file's top level
// runs twice in one document. `var` matters here (not `let`/`const`,
// which would throw on the second script tag's redeclaration) - and,
// unlike the pageIsWheelCollection/pageIsPromo/plpMounted vars below, this
// one has no initializer, so simply redeclaring it on the second run is
// already a no-op that leaves whatever the first run stored untouched.
var ggSharedPendingAiAgentFilters

function resolveSharedPendingAiAgentFilters() {
    if (typeof ggSharedPendingAiAgentFilters !== 'undefined') return ggSharedPendingAiAgentFilters
    ggSharedPendingAiAgentFilters = null
    var PENDING_KEY = 'aiAgentPendingCollectionFilters'
    var raw
    try {
        raw = localStorage.getItem(PENDING_KEY)
    } catch (e) {
        return ggSharedPendingAiAgentFilters
    }
    if (!raw) return ggSharedPendingAiAgentFilters
    localStorage.removeItem(PENDING_KEY)

    var pending
    try {
        pending = JSON.parse(raw)
    } catch (e) {
        return ggSharedPendingAiAgentFilters
    }

    var isFresh = pending && typeof pending.ts === 'number' && (Date.now() - pending.ts) < 5 * 60 * 1000
    var pendingFilters = Array.isArray(pending?.filters) ? pending.filters : []
    if (!isFresh || !pendingFilters.length) return ggSharedPendingAiAgentFilters

    var vehicleId
    try {
        vehicleId = localStorage.getItem('activeVehicleId') || null
    } catch (e) {
        vehicleId = null
    }
    ggSharedPendingAiAgentFilters = { filters: pendingFilters, vehicleId: vehicleId }
    return ggSharedPendingAiAgentFilters
}

function vuePLP(mountSelector) {
    mountSelector = mountSelector || '#PLP';
    const PLP = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {

            const mountedElement = document.querySelector(mountSelector);
            const isBestseller = mountSelector !== '#PLP';
            let wheelCollection = isBestseller ? (mountedElement?.dataset?.productType === 'wheels') : (window.pageIsWheelCollection || false);
            let isPromo = isBestseller ? false : (window.pageIsPromo || false);

            const collectionConfig = Vue.reactive({
                pageLength: 48,
                sortKey: "BEST_SELLING",
                descending: false,
                handle: isBestseller ? (mountedElement?.dataset?.collectionHandle || '') : window.location.pathname.replaceAll('/collections/', ''),
                vehicleFilters: [],
                pageFilters: [],
                cursor: '',
                locationCursor: '',
                hasNextPage: true,
                promo: isPromo,
                smartFilters: []
            })

            const checkedInputs = Vue.ref(collectionConfig.pageFilters)
            const filtersLoading = Vue.ref(true)
            let pendingAiAgentFiltersVehicleId = null

            const showFilters = Vue.computed(() => {
                return filtersLoading.value
            })

            const filters = Vue.reactive([])

            const isFilterDrawerOpen = Vue.ref(false)

            const expandedFilters = Vue.reactive({})

            const showSortUtility = Vue.ref(false);

            const sortSelector = Vue.ref("BEST_SELLING-ascending")

            const vehicleSearch = window.vehicleSearch()

            const storeSelector = window.storeSelector()

            const selectedStore = Vue.computed(() => storeSelector.nearestStore)

            const pageInitiated = Vue.ref(false)

            const checkedSource = Vue.ref(false);

            const checkedLoad = Vue.ref(false);

            const promoSort = (a, b) => {
                if (!collectionConfig.sortKey.includes('PRICE')) return;
                const valueA = a?.node?.promoUnitPrice
                    ? Number(a?.node?.promoUnitPrice?.replace('$', '').replace(',', ''))
                    : a?.node?.is_split
                        ? (Number(a?.node?.priceRange?.minVariantPrice?.amount) + Number(a?.node?.splitProduct?.node?.priceRange?.minVariantPrice?.amount)) / 2
                        : Number(a?.node?.priceRange?.minVariantPrice?.amount);
                const valueB = b?.node?.promoUnitPrice
                    ? Number(b?.node?.promoUnitPrice?.replace('$', '').replace(',', ''))
                    : b?.node?.is_split
                        ? (Number(b?.node?.priceRange?.minVariantPrice?.amount) + Number(b?.node?.splitProduct?.node?.priceRange?.minVariantPrice?.amount)) / 2
                        : Number(b?.node?.priceRange?.minVariantPrice?.amount);
                if (isNaN(valueA) || isNaN(valueB)) return;
                return collectionConfig.descending ? valueB - valueA : valueA - valueB;
            }

            const listening = Vue.ref(false)
            const isLoadingMore = Vue.ref(false)
            const isPlpRefreshing = Vue.ref(false)
            const useLoadMoreButton = Vue.ref(false)
            const showLoadMoreBtn = Vue.computed(() => useLoadMoreButton.value && collectionConfig.hasNextPage)
            const hasClickedLoadMore = Vue.ref(false)

            const cartAddingId = Vue.ref(null)
            const cartSuccessId = Vue.ref(null)
            let cartSuccessTimer = null

            const cartEnquiringId = Vue.ref(null);

            const smartFilterSet = Vue.ref({
                "4wd": [
                    {
                        title: "Commercial",
                        label: "Driving Style",
                        filtId: "filter.p.m.wheel_tyre_spec.driving_style",
                        namespace: "wheel_tyre_spec",
                        key: "driving_style",
                        values: [
                            'Light Commercial & Utes Tyre',
                            'Truck'
                        ],
                        defaultActive: false
                    },
                    {
                        title: "Snow",
                        label: "Driving Style",
                        filtId: "filter.p.m.wheel_tyre_spec.driving_style",
                        namespace: "wheel_tyre_spec",
                        key: "driving_style",
                        values: [
                            "All-Terrain Tyre - 3PMSF",
                            "All-Terrain Tyre – 3PMSF, M+S",
                            "Highway Tyre - 3PMSF",
                            "Mud Terrain Tyre - 3PMSF",
                            "Sport Performance Tyre - 3PMSF"
                        ],
                        defaultActive: false
                    },
                    {
                        title: "Mud",
                        label: "Driving Style",
                        filtId: "filter.p.m.wheel_tyre_spec.driving_style",
                        namespace: "wheel_tyre_spec",
                        key: "driving_style",
                        values: [
                            "Mud Terrain Tyre",
                            "Mud Terrain Tyre - 3PMSF",
                            "Mud Terrain Tyre - M+S"
                        ],
                        defaultActive: false
                    },
                    {
                        title: "All-Terrain",
                        label: "Driving Style",
                        filtId: "filter.p.m.wheel_tyre_spec.driving_style",
                        namespace: "wheel_tyre_spec",
                        key: "driving_style",
                        values: [
                            "All-Terrain Tyre",
                            "All-Terrain Tyre - 3PMSF",
                            "All-Terrain Tyre - M+S"
                        ],
                        defaultActive: false
                    }
                ]
            })

            const availabilityFilterTools = Vue.reactive({
                availabilityFiltered: {
                    today: false,
                    week: false
                },
                availabilitySplice: {
                    today: [],
                    week: []
                },
                unavailList: {
                    today: [],
                    week: []
                },
                initialLength: 0,
                filteredLength: 0,
                adjustmentLength: 0,
                availabilityFilter(filterList, type) { //"today" or "week"
                    for (let i = 0; i < filterList.length; i++) {
                        this.unavailList[type].unshift({
                            idx: filterList[i],
                            product: store.products.edges[filterList[i]]
                        });
                        store.products.edges.splice(filterList[i], 1);
                    }
                    this.adjustmentLength = this.adjustmentLength + filterList.length;
                    this.filteredLength = store.products.edges.length;
                },
                availabilityLists(products) {
                    let diff = 7 * 24 * 60 * 60 * 1000;
                    const now = Date.now();
                    const weekSpliceList = []
                    const todaySpliceList = []
                    for (let i = this.filteredLength; i < products.edges.length; i++) {
                        if (!products?.edges?.[i]?.node?.stock?.leadDate) {
                            weekSpliceList.unshift(i);
                            todaySpliceList.unshift(i);
                        } else {
                            if (products?.edges?.[i]?.node?.stock?.qtyInStore < products?.edges?.[i]?.node?.stock?.qty) todaySpliceList.unshift(i);
                            if (diff < (Date.parse(products?.[i]?.node?.splitProduct?.node?.stock?.leadDate) - now)) weekSpliceList.unshift(i);
                            if (products?.edges?.[i]?.node.is_split) {
                                if (!products?.edges?.[i]?.node?.splitProduct?.node?.stock?.leadDate) {
                                    if (!weekSpliceList.includes(i)) weekSpliceList.unshift(i);
                                    if (!todaySpliceList.includes(i)) todaySpliceList.unshift(i);
                                } else {
                                    if (products?.edges?.[i]?.node?.splitProduct?.node?.stock?.qty < products?.edges?.[i]?.node?.splitProduct?.node?.stock?.qty) if (!todaySpliceList.includes(i)) todaySpliceList.unshift(index + reduction);
                                    if (diff < (Date.parse(products?.edges?.[i]?.node?.splitProduct?.node?.stock?.leadDate) - now)) if (!weekSpliceList.includes(i)) weekSpliceList.unshift(index + reduction);
                                }
                            }
                        }
                    }
                    this.initialLength = this.initialLength + (products.edges.length - this.filteredLength);
                    return {
                        week: weekSpliceList,
                        today: todaySpliceList
                    };
                },
                toggleAvailabilityFilter(type) { //"today" or "week"
                    if (!this.availabilityFiltered[type]) this.availabilityFilter(this.availabilitySplice[type], type);
                    else {
                        this.unavailList[type].forEach((item) => {
                            store.products.edges.splice(item.idx, 0, item.product);
                        })
                        this.unavailList[type] = [];
                        this.initialLength = store.products.edges.length;
                        this.filteredLength = 0;
                    }
                    this.availabilityFiltered[type] = !this.availabilityFiltered[type];
                },
                updateAvailabilityFilter(products) {
                    const spliceAdditions = this.availabilityLists(products);
                    this.availabilitySplice["today"] = spliceAdditions.today.concat(this.availabilitySplice["today"]);
                    this.availabilitySplice["week"] = spliceAdditions.week.concat(this.availabilitySplice["week"]);
                    if (this.availabilityFiltered.today) this.availabilityFilter(spliceAdditions.today, "today");
                    if (this.availabilityFiltered.week) this.availabilityFilter(spliceAdditions.week, "week");
                }
            });



            const electricOverlay = (seconds) => {
                let freshCanvas = document.createElement('canvas');
                freshCanvas.id = 'canvas';
                freshCanvas.style.width = '100%';
                freshCanvas.style.height = '100%';
                freshCanvas.style.position = 'absolute';
                freshCanvas.style.top = 0;
                freshCanvas.style.left = 0;
                freshCanvas.style.zIndex = 5;
                let target = document.querySelector('.header-top');
                target.appendChild(freshCanvas);
                const canvas = document.getElementById("canvas");
                canvas.width = canvas.clientWidth;
                canvas.height = canvas.clientHeight;
                const ctx = canvas.getContext("2d");
                function canvasReducer() {
                    function reduceOpacity(iteration) {
                        ctx.globalAlpha = 1 - (iteration / 10);
                        ctx.globalCompositeOperation = 'copy';
                        ctx.drawImage(canvas, 0, 0);
                        ctx.globalCompositeOperation = 'source-over';
                    }
                    for (let i = 1; i < 11; i++) {
                        setTimeout(reduceOpacity, i * 100, i);
                    }
                }
                function canvasRemover() {
                    canvas.remove();
                }
                setTimeout(canvasReducer, (seconds - 1) * 1000);
                setTimeout(canvasRemover, seconds * 1000);

                const LEFT = "LEFT";
                const RIGHT = "RIGHT";

                const getDir = () => {
                    const dec = Math.floor(Math.random() * 30);
                    if (dec < 16) return LEFT;
                    else return RIGHT;
                };

                class Cloud {
                    constructor(x, y) {
                        this.x = x;
                        this.y = y;
                        this.size = Math.floor(Math.random() * 30);
                        this.clr = "transparent";
                        this.dir = getDir();
                        this.speed = Math.floor(Math.random() * 2) + 1;
                    }

                    // Movement helpers
                    moveLeft() {
                        this.x -= this.speed;
                    }
                    moveRight() {
                        this.x += this.speed;
                    }

                    update() {
                        if (this.x <= 0) {
                            this.dir = RIGHT;
                        } else if (this.x >= canvas.width) {
                            this.dir = LEFT;
                        }

                        if (this.dir === LEFT) this.moveLeft();
                        else this.moveRight();
                    }

                    drawRoot(x, y, col) {
                        let sx = x,
                            sy = y,
                            ex = sx + Math.floor(Math.random() * 50) - 15,
                            ey = sy + Math.floor(Math.random() * 30);

                        let i = 0,
                            limit = Math.floor(Math.random() * 20);

                        while (i < limit) {
                            ctx.beginPath();
                            ctx.strokeStyle = col;
                            ctx.lineWidth = 1;
                            ctx.moveTo(sx, sy);
                            ctx.lineTo(ex, ey);
                            ctx.stroke();

                            sx = ex;
                            sy = ey;
                            ex = sx + Math.floor(Math.random() * 50) - 15;
                            ey = sy + Math.floor(Math.random() * 30);
                            i++;
                        }
                    }

                    async drawLightning(color) {
                        ctx.fillStyle = "rgba(255, 255, 255, 0.1)";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);

                        let sx = this.x,
                            sy = this.y,
                            ex = sx + Math.floor(Math.random() * 30) - 15,
                            ey = sy + Math.floor(Math.random() * 30);

                        let i = 0,
                            limit = Math.floor(Math.random() * canvas.height);

                        while (i < limit) {
                            ctx.beginPath();
                            ctx.strokeStyle = color;
                            ctx.lineWidth = 3;
                            ctx.moveTo(sx, sy);
                            ctx.lineTo(ex, ey);
                            ctx.stroke();

                            sx = ex;
                            sy = ey;
                            ex = sx + Math.floor(Math.random() * 30) - 15;
                            ey = sy + Math.floor(Math.random() * 30);

                            let root = Math.floor(Math.random() * 1000);
                            if (root < 50) {
                                this.drawRoot(sx, sy, color);
                            }
                            i++;
                        }
                    }

                    draw() {
                        ctx.beginPath();
                        ctx.fillStyle = this.clr;
                        ctx.arc(this.x, this.y - 1, this.size, 0, 2 * Math.PI);
                        ctx.fill();

                        const chance = 0.002;
                        if (Math.random() < chance) {
                            this.drawLightning("#1cb3e9");
                        }
                    }
                }

                const clouds = [];
                let i = 0;

                while (i < canvas.width) {
                    clouds.push(new Cloud(i, 0));
                    i += Math.floor(Math.random() * 10) + 1;
                }

                const animate = () => {
                    ctx.shadowColor = "transparent";
                    ctx.shadowBlur = 10;
                    for (let c of clouds) {
                        c.draw();
                        c.update();
                    }

                    requestAnimationFrame(animate);
                };

                animate();

                window.addEventListener("resize", function () {
                    canvas.width = window.innerWidth;
                    canvas.height = window.innerHeight;
                });

            }

            const convertSmartFilterToPageFilter = (smartFilter) => {
                let pageFilterArray = []
                for (let i = 0; i < smartFilter.filters.length; i++) {
                    if (smartFilter.filters[i]?.inputType == "object") {
                        let inputEntries = Object.entries(smartFilter.filters[i]?.inputComponents);
                        let entryString = ''
                        for (let z = 0; z < inputEntries.length; z++) {
                            if (z > 0) {
                                if (typeof inputEntries[z][1] == 'number') {
                                    entryString = `${entryString},"${inputEntries[z][0]}":${inputEntries[z][1]}`
                                } else {
                                    entryString = `${entryString},"${inputEntries[z][0]}":"${inputEntries[z][1]}"`
                                }
                            } else {
                                if (typeof inputEntries[z][1] == 'number') {
                                    entryString = `"${inputEntries[z][0]}":${inputEntries[z][1]}`
                                } else {
                                    entryString = `"${inputEntries[z][0]}":"${inputEntries[z][1]}"`
                                }
                            }
                        }
                        if (entryString != '') {
                            let filterString = `{"${smartFilter.filters[i]?.inputTitle}":{${entryString}}}` || false;
                            if (filterString) {
                                pageFilterArray.push(filterString)
                            }
                        }
                    } else if (smartFilter.filters[i]?.inputType == "value") {
                        if (typeof smartFilter[i]?.inputValue == 'number') {
                            let filterString = `{"${smartFilter.filters[i].inputTitle}":${smartFilter.filters[i].inputValue}}` || false;
                            if (filterString) {
                                pageFilterArray.push(filterString)
                            }
                        } else {
                            let filterString = `{"${smartFilter.filters[i].inputTitle}":"${smartFilter.filters[i].inputValue}"}` || false;
                            if (filterString) {
                                pageFilterArray.push(filterString)
                            }
                        }
                    }
                }
                return pageFilterArray;
            }

            const getFlipSlotAvailable = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
                return flip[slotIndex]?.selectedAvailable ?? null;
            };


            const getFlipSlotLeadTime = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
                return flip[slotIndex]?.leadTimeDays ?? null;
            };

            const getFlipSlotStatus = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return 'none';
                const slot = flip[slotIndex];
                if (!slot) return 'none';
                if (slot.selectedAvailable === true) return 'nearest';
                if (slot.nearestStore !== false && slot.nearestStore != null) return 'nearby';
                return 'none';
            };

            const getFlipSlotPrice = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
                return flip[slotIndex]?.pricePerUnit ?? null;
            };

            let store = window.collectionStore();
            if (isBestseller) {
                store = Vue.reactive({
                    products: [],
                    stockCache: [],
                    showNoProdSection: false,
                    bestsellerRefresh: null,
                    setNoProdSection() { },
                    setBestsellerRefresh() { },
                    triggerBestsellerRefresh() { },
                });
            }
            const compareStore = window.compareStore ? window.compareStore() : null;
            compareStore?.loadFromStorage?.();
            const promoStore = window.promo();
            if (!promoStore._timerStarted) {
                promoStore._timerStarted = true;
                setInterval(() => { promoStore.currentTime = Date.now(); }, 1000);
            }
            const defaultTyreImage = window.defaultTyreImage;

            const products = Vue.computed(() => {
                return store.products
            })

            const showProduct = Vue.computed(() => {
                return store.products.edges ? false : true
            })

            const isCompareModalOpen = Vue.ref(false);
            const compareRef = compareStore || store;
            const normalizeCompareId = (value) => String(value || '').replace('gid://shopify/Product/', '');

            const canCompare = Vue.computed(() => (compareRef.selectedProducts || []).length >= 2);

            const toggleCompare = (product) => {
                // Check if product already exists
                const productId = product.id || product.node?.id;
                const normalizedProductId = normalizeCompareId(productId);
                const existingIndex = (compareRef.selectedProducts || []).findIndex(p =>
                    normalizeCompareId(p.id || p.node?.id) === normalizedProductId
                );

                if (existingIndex > -1) {
                    // Product already in compare - remove it
                    compareRef.selectedProducts.splice(existingIndex, 1);
                    compareStore?.persist?.();

                    // Close drawer if no products left
                    if (compareRef.selectedProducts.length === 0) {
                        compareRef.isDrawerOpen = false;
                        compareStore?.persist?.();
                    }
                    return;
                }


                if (compareRef.selectedProducts.length >= 3) {
                    console.warn("Max 3 products allowed");
                    compareStore?.showCompareLimitDialog?.("You can only compare up to 3 tyres");
                    return;
                }

                // Add product to store
                compareRef.selectedProducts.push({
                    id: productId,
                    title: product.title,
                    handle: product.handle || null,
                    price: product.priceRange.minVariantPrice.amount,
                    featured_image: product.images?.edges[0]?.node?.url || defaultTyreImage,
                    vendor: product.vendor,
                    available: product.availableForSale
                });

                // Open the drawer
                compareStore?.openCompareDrawer?.();
            };

            const isInCompare = (product) => {
                const productId = product.id || product.node?.id;
                if (!productId) return false;
                const normalizedProductId = normalizeCompareId(productId);
                return (compareRef.selectedProducts || []).some(p =>
                    normalizeCompareId(p.id || p.node?.id) === normalizedProductId
                );
            };
            const closeDrawer = () => {
                compareRef.isDrawerOpen = false;
                compareStore?.persist?.();
            };

            const totalCompare = () => {
                return (compareRef.selectedProducts || []).length;
            };

            const clearAll = () => {
                compareRef.selectedProducts = [];
                compareRef.isDrawerOpen = false;
                compareStore?.persist?.();
            };

            const clearAllFilters = () => {
                collectionConfig.pageFilters = [];
                checkedInputs.value = [];
                listening.value = false;
                collectionConfig.cursor = '';
                collectionConfig.hasNextPage = true;
                localStorage.removeItem('searchSizeFilters');
                try {
                    if (fitmentStore) {
                        fitmentStore.selectedFitment = null;
                    }
                } catch (e) { }
                newProdSearch();
            };

            const clearVehicleAndSeeAllTyres = () => {
                localStorage.removeItem('activeVehicleId');
                localStorage.removeItem('searchWidgetFilters');
                try {
                    if (fitmentStore) {
                        fitmentStore.selectedFitment = null;
                    }
                } catch (e) { }
                window.dispatchEvent(new CustomEvent('vehicle-updated', { detail: null }));
                collectionConfig.cursor = '';
                collectionConfig.hasNextPage = true;
                newProdSearch();
            };

            const removeFromCompare = (productId) => {
                const normalizedProductId = normalizeCompareId(productId);
                const index = (compareRef.selectedProducts || []).findIndex(
                    (p) => normalizeCompareId(p.id || p.node?.id) === normalizedProductId
                );
                if (index > -1) {
                    compareRef.selectedProducts.splice(index, 1);
                }

                if (!compareRef.selectedProducts.length) {
                    compareRef.isDrawerOpen = false;
                }
                compareStore?.persist?.();
            };

            const openCompareModal = () => {
                if (!canCompare.value) return;
                isCompareModalOpen.value = true;
                if (compareRef) {
                    compareRef.isCompareModalOpen = true
                    compareStore?.persist?.()
                }
            };

            const closeCompareModal = () => {
                isCompareModalOpen.value = false;
                if (compareRef) {
                    compareRef.isCompareModalOpen = false
                    compareStore?.persist?.()
                }
            };

            const closeHover = (event) => {
                const panel = event?.currentTarget?.closest('.productHoverPanel');
                if (panel) panel.classList.add('is-closed');
            };

            const resetHover = (event) => {
                const panel = event?.currentTarget?.querySelector('.productHoverPanel');
                panel?.classList.remove('is-closed');
            };

            const isFilterExpanded = (id) => {
                return !!expandedFilters[id]
            }

            const toggleFilterExpansion = (id) => {
                expandedFilters[id] = !expandedFilters[id]
            }

            const displayedFilterValues = (filter) => {
                if (!filter?.values) return []
                if (isFilterExpanded(filter.id)) return filter.values
                return filter.values.slice(0, 5)
            }

            const openFilterDrawer = () => {
                isFilterDrawerOpen.value = true
            }

            const closeFilterDrawer = () => {
                isFilterDrawerOpen.value = false
            }

            const toggleFilterDrawer = () => {
                isFilterDrawerOpen.value = !isFilterDrawerOpen.value
            }

            const quickFilters = Vue.ref([])


            const isQuickFilterActive = (input) => {
                return collectionConfig.smartFilters.includes(input)
            }

            const toggleQuickFilter = (input) => {
                const idx = collectionConfig.smartFilters.indexOf(input)
                if (idx > -1) {
                    let smartFilterArray = convertSmartFilterToPageFilter(input);
                    let spliceArray = smartFilterArray.flatMap((item) => {
                        let pageIdx = collectionConfig.pageFilters.findIndex(filt => filt == item)
                        if (pageIdx > -1) {
                            return pageIdx
                        } else {
                            return [];
                        }
                    })
                    for (let i = spliceArray.length - 1; i > -1; i--) {
                        collectionConfig.pageFilters.splice(spliceArray[i], 1);
                    }
                    collectionConfig.smartFilters.splice(idx, 1)
                } else {
                    collectionConfig.smartFilters.push(input);
                }
                listening.value = true
                checkedInputs.value = [...collectionConfig.pageFilters]
            }

            const stock = window.stock()

            const getStoredVehiclesForSelection = () => {
                try {
                    return JSON.parse(localStorage.getItem('vehicles') || '[]')
                } catch (e) {
                    return []
                }
            }

            const getSelectedVehicleForSelection = () => {
                const activeVehicleId = localStorage.getItem('activeVehicleId')
                const liveVehicles = Array.isArray(vehicleSearch.vehicles) ? vehicleSearch.vehicles : []
                const storedVehicles = getStoredVehiclesForSelection()
                if (!activeVehicleId) {
                    return null
                }

                const liveMatch = liveVehicles.find(v => String(v?.id) === String(activeVehicleId))
                if (liveMatch) return liveMatch

                return storedVehicles.find(v => String(v?.id) === String(activeVehicleId)) || null
            }


            let splitCheckSeq = 0

            const checkSplits = async () => {
                const getPatternTextFromTags = (tags) => {
                    if (!Array.isArray(tags)) return ''
                    const patternTag = tags.find(tag => typeof tag === 'string' && /^product\s*:/i.test(tag))
                    if (!patternTag) return ''
                    return patternTag.replace(/^product\s*:\s*/i, '').trim().toLowerCase()
                }
                const selectedVehicle = getSelectedVehicleForSelection()
                if (!selectedVehicle) {
                    for (let i = 0; i < store.products?.edges?.length; i++) {
                        store.products.edges[i].node.fits = 'ALL'
                    }
                    if (isBestseller) {
                        if (storeSelector?.nearestStore) {
                            await stock.PLPStockRequest(4, store.products?.edges);
                            availabilityFilterTools.updateAvailabilityFilter(store.products);
                        }
                    } else if (storeSelector?.nearestStore && localStorage.getItem('storesUnder100')) {
                        await stock.PLPStockRequest(4);
                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                    }
                    return
                }

                const productType = getCollectionProductType()
                let fitment
                let frontFitment
                let rearFitment
                if (productType === 'wheel') {
                    fitment = selectedVehicle?.fitmentInfo?.wheel_fitments?.[0] || null
                } else {
                    fitment = selectedVehicle?.fitmentInfo?.tyre_fitments?.[0] || null
                }
                if (fitment) {
                    if (productType === 'wheel') {
                        frontFitment = fitment.f_wheels || false
                        rearFitment = fitment.r_wheels || false
                    } else {
                        frontFitment = fitment.f_tyres || false
                        rearFitment = fitment.r_tyres || false
                    }
                } else {
                    fitment = productType === 'wheel'
                        ? selectedVehicle?.fitmentInfo?.tyre_fitments?.[0] || null
                        : selectedVehicle?.fitmentInfo?.wheel_fitments?.[0] || null
                    if (fitment) {
                        if (fitment.f_wheels || fitment.r_wheels) {
                            frontFitment = fitment.f_wheels || false
                            rearFitment = fitment.r_wheels || false
                        } else {
                            frontFitment = fitment.f_tyres || false
                            rearFitment = fitment.r_tyres || false
                        }
                    }
                }

                if (!fitment) {
                    for (let i = 0; i < store?.products?.edges?.length; i++) {
                        store.products.edges[i].node.fits = 'ALL'
                    }
                    if (isBestseller) {
                        if (storeSelector?.nearestStore) {
                            await stock.PLPStockRequest(4, store.products?.edges);
                            availabilityFilterTools.updateAvailabilityFilter(store.products);
                        }
                    } else if (storeSelector?.nearestStore && localStorage.getItem('storesUnder100')) {
                        await stock.PLPStockRequest(4);
                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                    }
                    return
                }
                if (fitment.is_split) {
                    let productSeries = ''
                    for (let i = 0; i < store?.products?.edges?.length; i++) {
                        if (typeof store.products.edges[i].node.is_split !== 'boolean') {
                            continue;
                        } else {
                            let pattern = store.products.edges[i].node?.tags?.filter(tag => tag.includes('product:'))[0]
                            if (pattern) {
                                let splitFilters = ''
                                let frontMatches = []
                                let rearMatches = []
                                let prodMatches = []
                                let parsedMeta = []
                                try {
                                    parsedMeta = JSON.parse(store.products.edges[i].node.metafield.value)
                                } catch (e) {
                                    parsedMeta = [store.products.edges[i].node.metafield.value]
                                }
                                for (let s = 0; s < parsedMeta.length; s++) {
                                    prodMatches.push(parsedMeta[s])
                                }
                                for (let s = 0; s < frontFitment.matches.length; s++) {
                                    let parsed = []
                                    try {
                                        parsed = JSON.parse(frontFitment.matches[s])
                                    } catch (e) {
                                        parsed = [frontFitment.matches[s]]
                                    }
                                    for (let f = 0; f < parsed.length; f++) {
                                        frontMatches.push(parsed[f])
                                    }
                                }
                                for (let s = 0; s < rearFitment.matches.length; s++) {
                                    let parsed = []

                                    try {
                                        parsed = JSON.parse(rearFitment.matches[s])
                                    } catch (e) {
                                        parsed = [rearFitment.matches[s]]
                                    }
                                    for (let f = 0; f < parsed.length; f++) {
                                        rearMatches.push(parsed[f])
                                    }
                                }
                                if (prodMatches.some(element => frontMatches.includes(element))) {
                                    store.products.edges[i].node.fits = 'FRONT'
                                    for (let q = 0; q < rearMatches.length; q++) {
                                        if (splitFilters == '') {
                                            splitFilters = `{productMetafield:{namespace:"wts",key:"sf",value:"${rearMatches[q].replaceAll('/', 'x').replaceAll(' ', '_')}"}}`
                                        } else {
                                            splitFilters = `${splitFilters},{productMetafield:{namespace:"wts",key:"sf",value:"${rearMatches[q].replaceAll('/', 'x').replaceAll(' ', '_')}"}}`
                                        }
                                    }
                                }
                                if (prodMatches.some(element => rearMatches.includes(element))) {
                                    store.products.edges[i].node.fits = 'REAR'
                                    for (let q = 0; q < frontMatches.length; q++) {
                                        if (splitFilters == '') {
                                            splitFilters = `{productMetafield:{namespace:"wts",key:"sf",value:"${frontMatches[q].replaceAll('/', 'x').replaceAll(' ', '_')}"}}`
                                        } else {
                                            splitFilters = `${splitFilters},{productMetafield:{namespace:"wts",key:"sf",value:"${frontMatches[q].replaceAll('/', 'x').replaceAll(' ', '_')}"}}`
                                        }
                                    }
                                }
                                if (splitFilters == '') {
                                    continue;
                                }
                                if (store?.products?.edges[i]?.node?.fits == 'REAR') {
                                    configureHandle('f')
                                } else if (store?.products?.edges[i]?.node?.fits == 'FRONT') {
                                    configureHandle('r')
                                }
                                if (collectionConfig.pageFilters[0]) {
                                    for (let i = 0; i < collectionConfig.pageFilters.length; i++) {
                                        let input = JSON.parse(collectionConfig.pageFilters[i])
                                        let valueString = ''
                                        if (typeof Object.values(input)[0] == "object") {
                                            for (let f = 0; f < Object.keys(Object.values(input)[0]).length; f++) {
                                                if (valueString == '') {
                                                    valueString = `${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                                                } else {
                                                    valueString = `${valueString},${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                                                }
                                            }
                                            if (splitFilters == '') {
                                                splitFilters = `{${Object.keys(input)[0]}:{${valueString}}}`
                                            } else {
                                                splitFilters = `${splitFilters},{${Object.keys(input)[0]}:{${valueString}}}`
                                            }
                                        } else {
                                            if (splitFilters == '') {
                                                splitFilters = `{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                                            } else {
                                                splitFilters = `${splitFilters},{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                                            }
                                        }
                                    }
                                }
                                if (splitFilters == '') {
                                    splitFilters = `{tag:"${pattern}"}`
                                } else {
                                    splitFilters = `${splitFilters},{tag:"${pattern}"}`
                                }
                                //Pratik - remove the sku fetch edge after test
                                splitFilters = `${splitFilters}`
                                productSeries = `${productSeries}
                                Product${i}: collection(handle:"${collectionConfig.handle}") {
                                    products(first:10, sortKey:${collectionConfig.sortKey}, reverse:${collectionConfig.descending}, filters:[${splitFilters}]) {
			                            edges {
				                            node {
					                            id
    					                        title
                                                productType
		    			                        tags
			    		                        vendor
				    	                        handle
					                            availableForSale
						                            priceRange {
						                            minVariantPrice {
							                            amount
						                            }
						                            maxVariantPrice {
							                            amount
						                            }
    					                        }
                                                collections(first:50) {
		    				                        edges {
			    				                        node {
                                                            id
                                                            title: metafield(namespace:"promotion",key:"title") {
					    				                        value
						    		                        }
							    	                        type: metafield(namespace:"promotion",key:"type") {
								    	                        value
								                            }
								                            value: metafield(namespace:"promotion",key:"value") {
									                            value
								                            }
                                                            colour: metafield(namespace:"promotion",key:"colour") {
									                            value
    								                        }
                                                            end_date: metafield(namespace:"promotion",key:"end_date") {
									                            value
    								                        }
	    						                        }
		    				                        }
			    		                        }
				                            }
			                            }
			                            pageInfo {
				                            hasNextPage
				                            endCursor
			                            }
		                            }
                                }`
                            }
                        }
                    }
                    if (productSeries) {
                        const currentSplitSeq = ++splitCheckSeq
                        let queryString = `{
		                                ${productSeries}
	                                }`
                        const options = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                            },
                            body: JSON.stringify({ query: queryString })
                        };
                        await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => {
                                if (response.status < 400) {
                                    return response.json()
                                } else {
                                    resolve('splitFail')
                                }
                            })
                            .then(object => {
                                if (currentSplitSeq !== splitCheckSeq) {
                                    return
                                }
                                let now = Date.parse(new Date());
                                let spliceList = []
                                let entries = Object.entries(object?.data || {})
                                for (let v = 0; v < entries.length; v++) {
                                    const key = entries[v][0]
                                    const payload = entries[v][1]
                                    if (!String(key).startsWith('Product')) continue
                                    if (payload?.products.edges && payload.products.edges.length > 0) {
                                        const baseIdx = Number(String(key).replaceAll('Product', ''))
                                        const baseEdge = store.products?.edges?.[baseIdx]
                                        const baseNode = baseEdge?.node
                                        if (!baseNode) continue
                                        const basePatternText = getPatternTextFromTags(baseNode?.tags)
                                        const patternMatchedEdges = payload.products.edges.filter(edge => {
                                            return getPatternTextFromTags(edge?.node?.tags) === basePatternText
                                        })
                                        if (!patternMatchedEdges.length) {
                                            continue
                                        }
                                        for (let q = 0; q < patternMatchedEdges.length; q++) {
                                            if (q === 0) {
                                                if (baseEdge.node.fits == 'REAR') {
                                                    spliceList.unshift(baseIdx)
                                                } else {
                                                    baseEdge.node.is_split = true
                                                    baseEdge.node.splitProduct = patternMatchedEdges[q]
                                                    const splitNodeId = patternMatchedEdges[q].node.id
                                                    const cachedSplit = store.stockCache.filter(p => p.node.id == splitNodeId && p.node.stockExpiry > now && p.node.stock.qty === 2)
                                                    if (cachedSplit.length > 0) {
                                                        baseEdge.node.splitProduct.node.stock = cachedSplit[0].node.stock
                                                        baseEdge.node.splitProduct.node.stockExpiry = cachedSplit[0].node.stockExpiry
                                                    }
                                                    baseEdge.node.sharedTags = baseEdge.node.tags.filter(tag => patternMatchedEdges[q].node.tags.includes(tag))
                                                    promoStore.calculatePromoValues(baseEdge.node)
                                                    let cachedStock = store.stockCache.filter(prod => prod.node.id == baseEdge.node.id && prod.node.stockExpiry > now && prod.node.stock.qty === 2)
                                                    if (cachedStock.length > 0) {
                                                        baseEdge.node.stockExpiry = cachedStock[0].node.stockExpiry
                                                        baseEdge.node.stock = cachedStock[0].node.stock
                                                    }
                                                }
                                            } else {
                                                //TODO: Handle multi split
                                                let newProd = baseEdge
                                                if (!newProd?.node) continue
                                                newProd.node.is_split = true
                                                newProd.node.splitProduct = patternMatchedEdges[q]
                                                const splitNodeId2 = patternMatchedEdges[q].node.id
                                                const cachedSplit2 = store.stockCache.filter(p => p.node.id == splitNodeId2 && p.node.stockExpiry > now && p.node.stock.qty === 2)
                                                if (cachedSplit2.length > 0) {
                                                    newProd.node.splitProduct.node.stock = cachedSplit2[0].node.stock
                                                    newProd.node.splitProduct.node.stockExpiry = cachedSplit2[0].node.stockExpiry
                                                }
                                                newProd.node.sharedTags = baseEdge.node.tags.filter(tag => patternMatchedEdges[q].node.tags.includes(tag))
                                                promoStore.calculatePromoValues(newProd.node)
                                                let cachedStock = store.stockCache.filter(prod => prod.node.id == newProd.node.id && prod.node.stockExpiry > now && prod.node.stock.qty === 2)
                                                if (cachedStock.length > 0) {
                                                    newProd.node.stockExpiry = cachedStock[0].node.stockExpiry
                                                    newProd.node.stock = cachedStock[0].node.stock
                                                }
                                                if (products?.edges?.filterIndex(edge => edge?.node?.id == newProd?.node?.id && edge?.node?.splitProduct?.node?.id == newProd?.node?.splitProduct?.node?.id) == -1) {
                                                    store.products.edges.push(newProd);
                                                }
                                            }
                                        }
                                    }
                                }
                                for (let v = 0; v < spliceList.length; v++) {
                                    store.products.edges.splice(spliceList[v], 1)
                                }
                            })
                            .catch(err => {
                                console.log('Error: failed to fetch split fitments')
                                console.log(`Error: ${err}`)
                            })
                            .finally(async () => {
                                if (storeSelector?.nearestStore) {
                                    if (isBestseller) {
                                        await stock.PLPStockRequest(2, store.products?.edges);
                                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                                    } else {
                                        await stock.PLPStockRequest(2);
                                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                                    }
                                }
                            })
                    } else {
                        if (storeSelector?.nearestStore) {
                            if (isBestseller) {
                                await stock.PLPStockRequest(2, store.products?.edges);
                                availabilityFilterTools.updateAvailabilityFilter(store.products);
                            } else {
                                await stock.PLPStockRequest(2);
                                availabilityFilterTools.updateAvailabilityFilter(store.products);
                            }
                        }
                    }
                } else {
                    for (let i = 0; i < store?.products?.edges?.length; i++) {
                        store.products.edges[i].node.fits = 'ALL'
                    }
                    if (storeSelector.nearestStore) {
                        if (isBestseller) {
                            await stock.PLPStockRequest(4, store.products?.edges);
                            availabilityFilterTools.updateAvailabilityFilter(store.products);
                        } else {
                            await stock.PLPStockRequest(4);
                            availabilityFilterTools.updateAvailabilityFilter(store.products);
                        }
                    }
                }
            }

            const configureHandle = (axle) => {
                const activeVehicle = getSelectedVehicleForSelection();
                if (!activeVehicle) {
                    if (!localStorage.getItem('searchWidgetFilters')) return;
                    try {
                        const widgetFilters = JSON.parse(localStorage.getItem('searchWidgetFilters'));
                        const rimDiameter = widgetFilters.find(filt => filt.productMetafield.namespace === 'wheel_tyre_spec' && filt.productMetafield.key === 'rim_diameter');
                        if (window.location.pathname.replaceAll('/collections/', '') === 'tyres') {
                            if (rimDiameter?.productMetafield?.value) collectionConfig.handle = rimDiameter.productMetafield.value;
                        } else if (window.location.pathname.replaceAll('/collections/', '') === 'wheels' || window.location.pathname.replaceAll('/collections/', '') == '4x4-wheels') {
                            if (rimDiameter?.productMetafield?.value) collectionConfig.handle = `${rimDiameter.productMetafield.value}w`;
                            if (window.location.pathname.replaceAll('/collections/', '') === '4x4-wheels') {
                                collectionConfig.pageFilters.push(`{"productType":"4X4 Wheel"}`)
                            }
                        }
                    } catch (e) {
                        return;
                    }
                }
                if (window.location.pathname.replaceAll('/collections/', '') === 'tyres') {
                    if (activeVehicle?.fitmentInfo?.tyre_fitments?.[0]?.[`${axle}_tyres`]?.matches?.length > 0) {
                        let val = activeVehicle.fitmentInfo.tyre_fitments[0][`${axle}_tyres`].matches[0].split('_')[0].split('R')[1].toString();
                        collectionConfig.handle = val;
                    }
                } else if (window.location.pathname.replaceAll('/collections/', '') === 'wheels' || window.location.pathname.replaceAll('/collections/', '') == '4x4-wheels') {
                    if (activeVehicle?.fitmentInfo?.wheel_fitments?.[0]?.[`${axle}_wheels`]?.matches?.length > 0) {
                        let val = activeVehicle.fitmentInfo.wheel_fitments[0][`${axle}_wheels`].matches[0].split('x')[0];
                        collectionConfig.handle = `${val}w`;
                        if (window.location.pathname.replaceAll('/collections/', '') === '4x4-wheels') {
                            collectionConfig.pageFilters.push(`{"productType":"4X4 Wheel"}`)
                        }
                    }
                }
                if (collectionConfig.handle.includes('.')) {
                    collectionConfig.handle = collectionConfig.handle.replaceAll('.', '-')
                }
            }

            const getCollection = async () => {
                if (window.name) {
                    localStorage.setItem(`${window.name}prevCollectionConfig`, JSON.stringify(collectionConfig))
                }

                const selectedVehicle = getSelectedVehicleForSelection()
                let splitString = ''

                if (selectedVehicle) {
                    if (selectedVehicle?.fitmentInfo?.tyre_fitments?.[0]?.is_split || selectedVehicle?.fitmentInfo?.wheel_fitments?.[0]?.is_split) {
                        splitString = `metafield(namespace:"wts",key:"sf") {
  						value
  					}`
                    }
                }
                let filters = collectionConfig.vehicleFilters

                configureHandle('f');

                let stringFilters = ''

                // See CORE_REQUIREMENTS.md / IMPLEMENTATION_NOTES.md for why
                // this check exists (skippedVehicleFitmentForSelectedVehicle).
                const skippedVehicleFitmentForSelectedVehicle = pendingAiAgentFiltersVehicleId !== null && String(selectedVehicle?.id) === String(pendingAiAgentFiltersVehicleId)
                if (selectedVehicle && filters.length == 0 && !skippedVehicleFitmentForSelectedVehicle) {
                    let output = {
                        data: {
                            collection: {
                                products: {
                                    edges: []
                                }
                            }
                        }
                    }
                    return output;
                }
                for (i = 0; i < filters.length; i++) {
                    if (stringFilters == '') {
                        stringFilters = `{productMetafield:{namespace:"wts",key:"sf",value:"${filters[i]}"}}`
                    } else {
                        stringFilters = `${stringFilters},{productMetafield:{namespace:"wts",key:"sf",value:"${filters[i]}"}}`
                    }
                }
                for (i = 0; i < collectionConfig.smartFilters.length; i++) {
                    let smartFilterArray = convertSmartFilterToPageFilter(collectionConfig.smartFilters[i])
                    smartFilterArray.map((item) => {
                        if (collectionConfig.pageFilters.findIndex(filt => filt === item) === -1) {
                            collectionConfig.pageFilters.push(item);
                        }
                    })
                }
                for (i = 0; i < collectionConfig.pageFilters.length; i++) {
                    let input = JSON.parse(collectionConfig.pageFilters[i])
                    let valueString = ''
                    if (typeof Object.values(input)[0] == "object") {
                        for (let f = 0; f < Object.keys(Object.values(input)[0]).length; f++) {
                            if (valueString == '') {
                                valueString = `${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                            } else {
                                valueString = `${valueString},${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                            }
                        }
                        if (stringFilters == '') {
                            stringFilters = `{${Object.keys(input)[0]}:{${valueString}}}`
                        } else {
                            stringFilters = `${stringFilters},{${Object.keys(input)[0]}:{${valueString}}}`
                        }
                    } else {
                        if (stringFilters == '') {
                            stringFilters = `{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                        } else {
                            stringFilters = `${stringFilters},{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                        }
                    }
                }
                if (stringFilters.length > 0) {
                    stringFilters = `${stringFilters},{available:true},{available:false}`;
                } else {
                    stringFilters = `{available:true},{available:false}`;
                }
                let storeAvail = '';
                if (wheelCollection) {
                    if (storeSelector?.location || localStorage.getItem('currentUserLocation')) {
                        let latitude = storeSelector?.location?.latitude || false;
                        let longitude = storeSelector?.location?.longitude || false;
                        if (!latitude || !longitude) {
                            if (localStorage.getItem('currentUserLocation')) {
                                try {
                                    let loc = JSON.parse(localStorage.getItem('currentUserLocation'))
                                    latitude = loc?.latitude || false;
                                    longitude = loc?.longitude || false;
                                } catch (e) {
                                    latitude = false;
                                    longitude = false;
                                }
                            }
                        }
                        if (latitude && longitude) {
                            storeAvail = `storeAvailability(first:10,near:{latitude:${latitude},longitude:${longitude}}) {
						edges {
							node {
								quantityAvailable
								location {
									name
								}
							}
						}
					}`
                        }
                    }
                }
                let queryString = `{
	                collection(handle:"${collectionConfig.handle}") {
		                products(first:${collectionConfig.pageLength}${collectionConfig.cursor}, sortKey:${collectionConfig.sortKey}, reverse:${collectionConfig.descending}, filters:[${stringFilters}]) {
			                edges {
				                node {
					                id
					                title
                                    productType
					                tags
					                vendor
					                handle
                                    category {
                                        name
                                    }
	                                availableForSale
	                                    variants(first:1) {
	                                        edges {
	                                            node {
	                                                    id
	                                                    sku
                                                        ${storeAvail}
	                                                }
	                                            }
	                                        }
                                    images(first:1) {
						                edges {
							                node {
								                altText
								                height
								                width
								                url
							                }
						                }
					                }
                                    collections(first:50) {
						                edges {
							                node {
                                                id
                                                title: metafield(namespace:"promotion",key:"title") {
                									value
								                }
								                type: metafield(namespace:"promotion",key:"type") {
									                value
								                }
                                                value: metafield(namespace:"promotion",key:"value") {
									                value
								                }
                                                colour: metafield(namespace:"promotion",key:"colour") {
									                value
								                }
                                                end_date: metafield(namespace:"promotion",key:"end_date") {
									                value
								                }
							                }
						                }
					                }
                                    ${splitString}
                                    bestDealText: metafield(namespace:"price",key:"best_deal_text") {
                                        value
                                    }
					                priceRange {
						                minVariantPrice {
							                amount
						                }
						                maxVariantPrice {
							                amount
						                }
					                }
				                }
			                }
			                pageInfo {
				                hasNextPage
				                endCursor
			                }
		                }
	                }
                }`
                const options = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: JSON.stringify({ query: queryString })
                };
                const collectionCall = new Promise(function (resolve, reject) {
                    fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                        .then(response => {
                            if (response.status < 400) {
                                return response.json()
                            } else {
                                resolve('PLPFail')
                            }
                        })
                        .then(object => {
                            const productsResponse = object?.data?.collection?.products
                            if (!productsResponse) {
                                resolve('PLPFail')
                                return
                            }
                            collectionConfig.hasNextPage = productsResponse.pageInfo.hasNextPage
                            if (productsResponse.pageInfo.hasNextPage) {
                                collectionConfig.cursor = `, after:"${productsResponse.pageInfo.endCursor}"`
                            } else {
                                collectionConfig.cursor = ''
                            }
                            if (object?.data?.collection?.products?.edges) {
                                let spliceArray = [];
                                let shiftArray = [];
                                for (let i = 0; i < object.data.collection.products.edges.length; i++) {
                                    if (object?.data?.collection?.products?.edges[i]?.node?.priceRange?.minVariantPrice?.amount) {
                                        object.data.collection.products.edges[i].node.price = promoStore.priceFormat(
                                            object.data.collection.products.edges[i].node.priceRange.minVariantPrice.amount
                                        )
                                    }
                                    if (object?.data?.collection?.products?.edges[i]?.node?.category?.name.toLowerCase().includes('wheel')) {
                                        object.data.collection.products.edges[i].node.isWheel = true;
                                    } else {
                                        object.data.collection.products.edges[i].node.isWheel = false;
                                    }
                                    //best price toggle code
                                    if (enableBestPriceXMonths) {
                                        const bestDealTextRaw = object?.data?.collection?.products?.edges[i]?.node?.bestDealText?.value;
                                        if (bestDealTextRaw) {
                                            try {
                                                const bdt = JSON.parse(bestDealTextRaw);
                                                if (bdt.best_deal_text) {
                                                    object.data.collection.products.edges[i].node.priceDropData = {
                                                        label: bdt.best_deal_text
                                                    };
                                                }
                                            } catch (e) { }
                                        }
                                    }
                                    if (wheelCollection && object?.data?.collection?.products?.edges?.[i]?.node?.variants?.edges?.[0]?.node?.storeAvailability?.edges?.length > 0) {
                                        if (object?.data?.collection?.products?.edges?.[i]?.node?.variants?.edges?.[0]?.node?.storeAvailability?.edges?.findIndex(edge => edge?.node?.quantityAvailable > 0 && !edge?.node?.location?.name?.toLowerCase().includes('warehouse')) > -1) {
                                            spliceArray.unshift(i);
                                        }
                                    }
                                }
                                for (let i = 0; i < spliceArray.length; i++) {
                                    shiftArray.push(object.data.collection.products.edges.splice(spliceArray[i], 1)[0])
                                }
                                for (let i = 0; i < shiftArray.length; i++) {
                                    object.data.collection.products.edges.unshift(shiftArray[i])
                                }
                            }
                            resolve(object);
                        })
                        .catch(err => {
                            console.log('Error: failed to fetch products')
                            console.log(`Error: ${err}`)
                            resolve('PLPFail')
                        })
                })
                let now = Date.parse(new Date())
                const collectionResponse = await collectionCall
                if (collectionResponse?.data?.collection?.products?.edges) {
                    for (let i = 0; i < collectionResponse.data.collection.products.edges.length; i++) {
                        let cachedStock = [];
                        if (wheelCollection) {
                            if (selectedVehicle?.fitmentInfo?.wheel_fitments?.[0]?.is_split) {
                                cachedStock = store.stockCache.filter(prod => prod.node.id == collectionResponse.data.collection.products.edges[i].node.id && prod.node.stockExpiry > now && prod.node.stock.qty === 2);
                            } else {
                                cachedStock = store.stockCache.filter(prod => prod.node.id == collectionResponse.data.collection.products.edges[i].node.id && prod.node.stockExpiry > now && prod.node.stock.qty === 4);
                            }
                        } else {
                            if (selectedVehicle?.fitmentInfo?.tyre_fitments?.[0]?.is_split) {
                                cachedStock = store.stockCache.filter(prod => prod.node.id == collectionResponse.data.collection.products.edges[i].node.id && prod.node.stockExpiry > now && prod.node.stock.qty === 2);
                            } else {
                                cachedStock = store.stockCache.filter(prod => prod.node.id == collectionResponse.data.collection.products.edges[i].node.id && prod.node.stockExpiry > now && prod.node.stock.qty === 4);
                            }
                        }
                        if (cachedStock.length > 0) {
                            collectionResponse.data.collection.products.edges[i].node.stockExpiry = cachedStock[0].node.stockExpiry
                            collectionResponse.data.collection.products.edges[i].node.stock = cachedStock[0].node.stock
                        }

                        collectionResponse.data.collection.products.edges[i].node.is_split = !!collectionResponse.data.collection.products.edges[i].node?.splitProduct?.node || !!collectionResponse.data.collection.products.edges[i].node?.is_split
                        promoStore.calculatePromoValues(collectionResponse.data.collection.products.edges[i].node)

                    }
                }
                return collectionResponse
            }

            //Call filters that apply to this page and the counts for each filter value
            const getFilters = async () => {
                const vehicleFilters = [...new Set((collectionConfig.vehicleFilters || []).filter(Boolean))]
                const filterParts = [];

                const selectedVehicle = getSelectedVehicleForSelection()

                configureHandle('f');

                // See the matching comment in getCollection() above.
                const skippedVehicleFitmentForSelectedVehicle = pendingAiAgentFiltersVehicleId !== null && String(selectedVehicle?.id) === String(pendingAiAgentFiltersVehicleId)
                if (selectedVehicle && vehicleFilters.length == 0 && !skippedVehicleFitmentForSelectedVehicle) {
                    let output = {
                        data: {
                            collection: {
                                products: {
                                    filters: []
                                }
                            }
                        }
                    }
                    return output;
                }

                for (let i = 0; i < vehicleFilters.length; i++) {
                    filterParts.push(`{productMetafield:{namespace:"wts",key:"sf",value:"${vehicleFilters[i]}"}}`)
                }
                for (let i = 0; i < collectionConfig.pageFilters.length; i++) {
                    let input = JSON.parse(collectionConfig.pageFilters[i])
                    let valueString = ''
                    if (typeof Object.values(input)[0] == "object") {
                        for (let f = 0; f < Object.keys(Object.values(input)[0]).length; f++) {
                            if (valueString == '') {
                                valueString = `${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                            } else {
                                valueString = `${valueString},${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                            }
                        }
                        filterParts.push(`{${Object.keys(input)[0]}:{${valueString}}}`)
                    } else {
                        filterParts.push(`{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`)
                    }
                }
                let stringFilters = filterParts.join(',')
                if (stringFilters.length > 0) {
                    stringFilters = `${stringFilters},{available:true},{available:false}`
                } else {
                    stringFilters = `{available:true},{available:false}`
                }
                let queryString = `{
                                    collection(handle:"${collectionConfig.handle}") {
                                        products(first:1, filters:[${stringFilters}]) {
                                            filters {
                                                id
                                                label
                                                values {
                                                    id
                                                    label
                                                    count
                                                    input
                                                }
                                            }
                                        }
                                    }
                                }`
                const options = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: JSON.stringify({ query: queryString })
                };
                const filterCall = new Promise(function (resolve, reject) {
                    fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                        .then(response => {
                            if (response.status < 400) {
                                return response.json()
                            } else {
                                resolve('FilterFail')
                            }
                        })
                        .then(object => {
                            resolve(object);
                            reject('FilterFail');
                        })
                        .catch(err => {
                            console.log('Error: failed to fetch filters')
                            console.log(`Error: ${err}`)
                        })
                })
                const filterResponse = await filterCall;
                return filterResponse;
            }

            //Add next pagination of collection to product array when user scrolls more than halfway down the page
            const infiniteScroll = async () => {
                const scrollBottom = window.innerHeight + window.scrollY;
                const pageHeight = document.documentElement.scrollHeight;

                if (scrollBottom >= pageHeight - 200 && collectionConfig.hasNextPage && !isLoadingMore.value) {
                    isLoadingMore.value = true
                    await getCollection().then(async (prodUpdate) => {
                        if (prodUpdate !== 'PLPFail') {
                            const newEdges = prodUpdate.data.collection.products.edges || [];

                            if (!store.products.edges) {
                                store.products.edges = newEdges;
                            } else {
                                store.products.edges = store.products.edges.concat(newEdges);
                            }
                            await checkSplits();
                            if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                        }
                    }).finally(() => {
                        isLoadingMore.value = false
                        Vue.nextTick(() => {
                            document.removeEventListener('scroll', infiniteScroll)
                            if (collectionConfig.hasNextPage) {
                                document.addEventListener('scroll', infiniteScroll)
                            }
                        })
                    });
                }
            };

            const loadMore = async () => {
                if (!collectionConfig.hasNextPage || isLoadingMore.value) return
                hasClickedLoadMore.value = true
                isLoadingMore.value = true

                await getCollection().then(async (prodUpdate) => {
                    if (prodUpdate !== 'PLPFail') {
                        const newEdges = prodUpdate.data.collection.products.edges || []
                        store.products.edges = store.products.edges
                            ? store.products.edges.concat(newEdges)
                            : newEdges;
                        await checkSplits();
                        if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                    }
                }).finally(() => {
                    isLoadingMore.value = false
                    if (collectionConfig.hasNextPage) {
                        document.addEventListener('scroll', infiniteScroll)
                    }
                })
            }

            hasClickedLoadMore.value = false
            document.removeEventListener('scroll', infiniteScroll)   // reset on every new search


            //Product call and filter call to be used when page first loads or the filters are changed
            const newProdSearch = async () => {
                availabilityFilterTools.availabilityFiltered.today = false;
                availabilityFilterTools.availabilityFiltered.week = false;
                availabilityFilterTools.availabilitySplice.today = [];
                availabilityFilterTools.availabilitySplice.week = [];
                availabilityFilterTools.unavailList.today = [];
                availabilityFilterTools.unavailList.week = [];
                availabilityFilterTools.initialLength = 0;
                availabilityFilterTools.filteredLength = 0;
                availabilityFilterTools.adjustmentLength = 0;
                showSortUtility.value = false;
                if (checkedSource.value) {
                    checkedLoad.value = true;
                }
                hasClickedLoadMore.value = false
                useLoadMoreButton.value = false
                document.removeEventListener('scroll', infiniteScroll)
                isPlpRefreshing.value = true;
                filtersLoading.value = true;
                if (localStorage.getItem('searchWidgetFilters')) {
                    try {
                        let widgFilters = JSON.parse(localStorage.getItem('searchWidgetFilters'));
                        for (let i = 0; i < widgFilters.length; i++) {
                            if (((window.location.pathname.replaceAll('/collections/', '') === 'wheels' || window.location.pathname.replaceAll('/collections/', '') === '4x4-wheels') && widgFilters?.[i]?.productMetafield?.key === 'rim_diameter')
                                || (window.location.pathname.replaceAll('/collections/', '') !== 'wheels' && window.location.pathname.replaceAll('/collections/', '') !== '4x4-wheels')) {
                                if (typeof widgFilters[i] == 'object') {
                                    widgFilters[i] = JSON.stringify(widgFilters[i]);
                                }
                                if (!collectionConfig.pageFilters.includes(widgFilters[i])) {
                                    collectionConfig.pageFilters.push(widgFilters[i]);
                                }
                            }
                        }
                        //collectionConfig.sortKey = 'PRICE';
                        //sortSelector.value = 'PRICE-ascending';
                    } catch (err) {
                        console.error(`Error loading dropdown size filters: ${err}`);
                    }
                }
                collectionConfig.cursor = '';
                collectionConfig.hasNextPage = true;
                try {
                    const vehicle = getSelectedVehicleForSelection()
                    const skipVehicleFitmentFilters = pendingAiAgentFiltersVehicleId !== null && String(vehicle?.id) === String(pendingAiAgentFiltersVehicleId)

                    if (vehicle && !localStorage.getItem('searchWidgetFilters') && !skipVehicleFitmentFilters) {
                        const productType = getCollectionProductType()
                        let fitment = []
                        const includeTyres = !wheelCollection;
                        const includeWheels = wheelCollection;

                        if (includeTyres) {
                            if (vehicle.fitmentInfo?.tyre_fitments[0]?.f_tyres) {
                                fitment.push(vehicle.fitmentInfo.tyre_fitments[0].f_tyres)
                            }
                            if (vehicle.fitmentInfo?.tyre_fitments[0]?.is_split && vehicle.fitmentInfo?.tyre_fitments[0]?.r_tyres) {
                                fitment.push(vehicle.fitmentInfo.tyre_fitments[0].r_tyres)
                            }
                            if (vehicle.is_run_flat) {
                                let eIdx = quickFilters.value.findIndex(filt => filt.title == 'Run Flat Only')
                                if (eIdx === -1) {
                                    let rfFilter = {
                                        "title": "Run Flat Only",
                                        "filters": [
                                            {
                                                "id": "filter.p.m.tyre_spec.run_flat",
                                                "label": "Run Flat",
                                                "inputType": "object",
                                                "inputTitle": "productMetafield",
                                                "inputComponents": {
                                                    "namespace": "tyre_spec",
                                                    "key": "run_flat",
                                                    "value": "true"
                                                }
                                            }
                                        ]
                                    }
                                    collectionConfig.smartFilters.push(rfFilter);
                                    quickFilters.value.push(rfFilter);
                                }
                            }
                            if (vehicle.is_electric) {
                                let eIdx = quickFilters.value.findIndex(filt => filt.title == 'Electric')
                                if (eIdx === -1) {
                                    let electricFilter = {
                                        "title": "Electric",
                                        "filters": [
                                            {
                                                "id": "filter.p.m.tyre_spec.ev_tyre",
                                                "label": "EV Tyre",
                                                "inputType": "object",
                                                "inputTitle": "productMetafield",
                                                "inputComponents": {
                                                    "namespace": "tyre_spec",
                                                    "key": "ev_tyre",
                                                    "value": "true"
                                                }
                                            }
                                        ]
                                    }
                                    collectionConfig.smartFilters.push(electricFilter);
                                    quickFilters.value.push(electricFilter);
                                }
                            }
                        }
                        if (includeWheels) {
                            if (vehicle.fitmentInfo?.wheel_fitments[0]?.f_wheels) {
                                fitment.push(vehicle.fitmentInfo.wheel_fitments[0].f_wheels)
                            }
                            if (vehicle.fitmentInfo?.wheel_fitments[0]?.is_split && vehicle.fitmentInfo?.wheel_fitments[0]?.r_wheels) {
                                fitment.push(vehicle.fitmentInfo.wheel_fitments[0].r_wheels)
                            }
                        }
                        collectionConfig.vehicleFilters = []

                        if (fitment && fitment.length > 0) {
                            for (let i = 0; i < fitment.length; i++) {
                                if (fitment[i]?.matches && fitment[i].matches?.length > 0) {
                                    collectionConfig.vehicleFilters = collectionConfig.vehicleFilters.concat(fitment[i].matches)
                                }
                            }
                        }

                        /*if (!pageInitiated.value && sortSelector.value === 'BEST_SELLING-ascending') {
                            if ((new Date().getFullYear() - vehicleSearch.vehicleAgeReversal) < vehicle.manufactureYear) {
                                collectionConfig.descending = true
                                sortSelector.value = 'PRICE-descending'
                            } else {
                                collectionConfig.descending = false
                                sortSelector.value = 'PRICE-ascending'
                            }
                            collectionConfig.sortKey = 'PRICE'
                        }*/
                        localStorage.removeItem('searchWidgetFilters')
                    } else {
                        // Clear vehicle filters to ensure we get all products
                        collectionConfig.vehicleFilters = []
                    }

                    await getCollection().then(async (collection) => {
                        if (collection != 'PLPFail') {
                            Object.assign(store.products, collection.data.collection.products);
                            await checkSplits();
                            if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                        }
                    })

                    await getFilters().then(newFilters => {
                        if (newFilters != 'FilterFail') {
                            let fullIndex = newFilters.data.collection.products.filters.findIndex(filter => filter.id == 'filter.p.m.wts.sf')
                            if (fullIndex > -1) {
                                newFilters.data.collection.products.filters.splice(fullIndex, 1)
                            }
                            let tagIndex = newFilters.data.collection.products.filters.findIndex(filter => filter.id == 'filter.p.tag')
                            if (tagIndex > -1) {
                                newFilters.data.collection.products.filters.splice(tagIndex, 1)
                            }
                            let rfIndex = newFilters?.data?.collection?.products?.filters?.findIndex(filter => filter?.id == 'filter.p.m.tyre_spec.run_flat')
                            if (rfIndex > -1) {
                                let falseIndex = newFilters?.data?.collection?.products?.filters[rfIndex]?.values?.findIndex(val => val.id === 'filter.p.m.tyre_spec.run_flat.0');
                                if (falseIndex > -1) {
                                    newFilters.data.collection.products.filters[rfIndex].values.splice(falseIndex, 1)
                                }
                            }
                            if (localStorage.getItem('searchWidgetFilters') || collectionConfig.vehicleFilters.length > 0) {
                                if (!wheelCollection) {
                                    let aspectIndex = newFilters.data.collection.products.filters.findIndex(filter => filter.id == 'filter.p.m.tyre_spec.aspect_ratio')
                                    if (aspectIndex > -1) {
                                        newFilters.data.collection.products.filters.splice(aspectIndex, 1)
                                    }
                                    let rimIndex = newFilters.data.collection.products.filters.findIndex(filter => filter.id == 'filter.p.m.wheel_tyre_spec.rim_diameter')
                                    if (rimIndex > -1) {
                                        newFilters.data.collection.products.filters.splice(rimIndex, 1)
                                    }
                                    let widthIndex = newFilters.data.collection.products.filters.findIndex(filter => filter.id == 'filter.p.m.wheel_tyre_spec.width')
                                    if (widthIndex > -1) {
                                        newFilters.data.collection.products.filters.splice(widthIndex, 1)
                                    }
                                } else {
                                    //TODO: Check on this output
                                    let rimIndex = newFilters.data.collection.products.filters.findIndex(filter => filter.id == 'filter.p.m.wheel_tyre_spec.rim_diameter')
                                    if (rimIndex > -1) {
                                        newFilters.data.collection.products.filters.splice(rimIndex, 1)
                                    }
                                }
                            }
                            if (vehicle && !wheelCollection && newFilters?.data?.collection?.products?.filters) {
                                let catIdx = vehicle?.categories?.findIndex(cat => cat.key === 'fq');
                                if (catIdx > -1 && (vehicle?.categories?.[catIdx]?.value === '4wd' || vehicle?.categories?.[catIdx]?.value === 'cpm') && smartFilterSet?.value?.['4wd']) {
                                    createLoadIndexSmartFilter(vehicle, newFilters.data.collection.products.filters)
                                    for (let i = 0; i < smartFilterSet.value['4wd'].length; i++) {
                                        createMetafieldFilter(smartFilterSet.value['4wd'][i].title, smartFilterSet.value['4wd'][i].label, smartFilterSet.value['4wd'][i].filtId, smartFilterSet.value['4wd'][i].namespace, smartFilterSet.value['4wd'][i].key, smartFilterSet.value['4wd'][i].values, newFilters.data.collection.products.filters, smartFilterSet.value['4wd'][i].defaultActive);
                                    }
                                }
                            }
                            for (let i = 0; i < newFilters.data.collection.products.filters.length; i++) {
                                newFilters.data.collection.products.filters[i].values = newFilters.data.collection.products.filters[i].values.filter(val => val.count > 0);
                            }
                            newFilters.data.collection.products.filters = newFilters.data.collection.products.filters.filter(filt => filt.values.length > 1 || filt.id === "filter.p.m.tyre_spec.run_flat")
                            let splicers = []
                            for (let i = 0; i < newFilters.data.collection.products.filters.length; i++) {
                                if (newFilters.data.collection.products.filters[i].values.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0) == 0) {
                                    splicers.unshift(i);
                                }
                            }
                            for (let i = 0; i < splicers.length; i++) {
                                newFilters.data.collection.products.filters.splice(splicers[i], 1);
                            }
                            filters.splice(0, filters.length)
                            for (let i = 0; i < newFilters.data.collection.products.filters.length; i++) {
                                filters.push(newFilters.data.collection.products.filters[i]);
                            }
                            checkedLoad.value = false;
                            checkedSource.value = false;
                            listening.value = true;
                        }
                    })

                    const hasVehicleOrSize = !!localStorage.getItem('activeVehicleId') || !!localStorage.getItem('selectedSizeDisplay')
                    if (hasVehicleOrSize) {
                        document.addEventListener('scroll', infiniteScroll)
                    } else {
                        useLoadMoreButton.value = true
                    }
                } finally {
                    if (promoStore.needScroll) {
                        const pane = document.getElementById('promoPane');
                        if (pane) {
                            const paneY = pane.getBoundingClientRect().top;
                            const navHeight = Number(window.getComputedStyle(document.querySelector('.header-nav')).height.replace('px', ''));
                            const headerHeight = Number(window.getComputedStyle(document.querySelector('.header-top')).height.replace('px', ''));
                            window.scrollTo(0, paneY - navHeight - headerHeight);
                        }
                        promoStore.needScroll = false;
                    }
                    filtersLoading.value = false;
                    isPlpRefreshing.value = false
                    if (vehicleSearch?.vehicles?.[0]?.is_electric) {
                        if (electricOverlay && !localStorage.getItem('zapped')) {
                            electricOverlay(electricDuration);
                            localStorage.setItem('zapped', 'true');
                        }
                    }
                    if (!isBestseller) {
                        Vue.nextTick(() => {
                            store.setNoProdSection(!productsExist.value && !!vehicleName.value);
                        });
                    }
                }
                pageInitiated.value = true;
            }

            const extractLoadIndex = (baseDesc) => {
                if (baseDesc.split(' ').length === 2) {
                    let loadSpeed = baseDesc.split(' ')[1];
                    let loadIndex = loadSpeed.replace(/\D/g, "");
                    if (isNaN(loadIndex)) return false;
                    return loadIndex;
                } else {
                    return false;
                }
            }

            const createLoadIndexSmartFilter = (vehicle, filters) => {
                let tIdx = quickFilters.value.findIndex(filt => filt.title == 'Towing')
                if (tIdx === -1) {
                    if (vehicle?.fitmentInfo?.tyre_fitments?.[0]?.f_tyres?.full_desc) {
                        let loadIndex = extractLoadIndex(vehicle?.fitmentInfo?.tyre_fitments?.[0]?.f_tyres?.full_desc)
                        if (loadIndex) {
                            let liIndex = filters.findIndex(filter => filter.id == "filter.p.m.tyre_spec.load_index");
                            if (liIndex > -1) {
                                let sortedLoadFilterValues = filters[liIndex].values.sort((a, b) => Number(a.label) - Number(b.label));
                                let vehicleLiIndex = sortedLoadFilterValues.findIndex(val => val.label === loadIndex);
                                if (vehicleLiIndex > -1) {
                                    if (sortedLoadFilterValues.length > vehicleLiIndex + 3) {
                                        let splicedFilterValues = sortedLoadFilterValues.splice(vehicleLiIndex + 3);
                                        let filteredFilterValues = splicedFilterValues.filter(val => val.count > 0);
                                        if (filteredFilterValues.length > 0) {
                                            let towingFilters = filteredFilterValues.flatMap((value) => {
                                                if (value?.label) {
                                                    return {
                                                        "id": "filter.p.m.tyre_spec.load_index",
                                                        "label": "Load Index",
                                                        "inputType": "object",
                                                        "inputTitle": "productMetafield",
                                                        "inputComponents": {
                                                            "namespace": "tyre_spec",
                                                            "key": "load_index",
                                                            "value": value?.label
                                                        }
                                                    }
                                                }
                                            })
                                            let towFilter = {
                                                "title": "Towing",
                                                "filters": towingFilters
                                            }
                                            quickFilters.value.push(towFilter);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            const createMetafieldFilter = (title, label, filtId, namespace, key, values, filters, defaultActive) => {
                let fIndex = filters.findIndex(filter => filter?.id === filtId);
                if (fIndex > -1) {
                    let validValues = filters?.[fIndex]?.values?.filter(val => values.includes(val.label) && val.count > 0);
                    let namespaceKeyInUse = collectionConfig?.smartFilters?.findIndex(filt => filt?.title != title && filt?.filters?.findIndex(subFilt => subFilt?.inputComponents?.namespace === namespace && subFilt?.inputComponents?.key === key) > -1)
                    if (validValues.length > 0 && namespaceKeyInUse === -1) {
                        let qfIdx = quickFilters.value.findIndex(filt => filt.title == title);
                        if (qfIdx === -1) {
                            let sfFilters = validValues.flatMap((value) => {
                                if (value?.label) {
                                    return {
                                        "id": filtId,
                                        "label": label,
                                        "inputType": "object",
                                        "inputTitle": "productMetafield",
                                        "inputComponents": {
                                            "namespace": namespace,
                                            "key": key,
                                            "value": value?.label
                                        }
                                    }
                                }
                            })
                            let smartFilter = {
                                "title": title,
                                "filters": sfFilters
                            }
                            if (defaultActive) {
                                collectionConfig.smartFilters.push(smartFilter);
                            }
                            quickFilters.value.push(smartFilter);
                        }
                    } else {
                        let qIdx = quickFilters.value.findIndex(val => val.title === title)
                        if (qIdx > -1) {
                            quickFilters.value.splice(qIdx, 1);
                        }
                    }
                }
            }

            // One-time handoff from the AI agent overlay's "see these tyres
            // on the website" link (see assets/GGagentOverlay.js's
            // #renderProducts) - this page has no URL-param filter handling
            // at all, so the overlay can't just link in a query string; it
            // writes the intended filters here instead, as the exact same
            // JSON-string shape Shopify's own filter checkboxes use (see
            // `value.input` in sections/GGcollectionGrid.liquid). The
            // underlying localStorage key is one-shot (same pattern as the
            // `searchWidgetFilters`/`activeVehicleId` keys elsewhere in this
            // file), but resolveSharedPendingAiAgentFilters() caches the
            // parsed result at module scope so every vuePLP() instance on
            // this page - not just whichever one happens to mount first -
            // can apply it.
            const applyPendingAiAgentFilters = () => {
                const resolved = resolveSharedPendingAiAgentFilters()
                if (!resolved) return

                let changed = false
                for (let i = 0; i < resolved.filters.length; i++) {
                    const filterString = resolved.filters[i]
                    if (typeof filterString !== 'string') continue
                    try {
                        // Must be valid JSON - getCollection() JSON.parses
                        // every pageFilters entry when building the query.
                        JSON.parse(filterString)
                    } catch (e) {
                        continue
                    }
                    if (collectionConfig.pageFilters.indexOf(filterString) === -1) {
                        collectionConfig.pageFilters.push(filterString)
                        changed = true
                    }
                }
                if (changed) {
                    checkedInputs.value = [...collectionConfig.pageFilters]
                    // See the doc comment on the declaration above for why
                    // this is anchored to a vehicle id rather than a one-shot
                    // flag or a timer.
                    pendingAiAgentFiltersVehicleId = resolved.vehicleId
                }
            }

            //Check for vehicle details and fitment filters when page first loads then trigger initial product call
            Vue.onMounted(() => {
                applyPendingAiAgentFilters()
                newProdSearch()
            })

            //Watch for change in sort from dropdown and trigger new product call if changed
            Vue.watch(sortSelector, (newValue) => {
                if (pageInitiated.value) {
                    collectionConfig.sortKey = newValue.split('-')[0]
                    if (newValue.split('-')[1] == 'ascending') {
                        collectionConfig.descending = false
                    } else if (newValue.split('-')[1] == 'descending') {
                        collectionConfig.descending = true
                    }
                    collectionConfig.cursor = ''
                    collectionConfig.hasNextPage = true;
                    newProdSearch()
                }
            })

            const watchStockComplete = Vue.ref(false);

            const stockRequestActive = Vue.computed(() => stock.stockLoading);

            Vue.watch(selectedStore, (newValue, oldValue) => {
                if (newValue !== oldValue) watchStockComplete.value = true;
            })

            Vue.watch(stockRequestActive, (newValue) => {
                if (!watchStockComplete.value) return
                if (!newValue) {
                    availabilityFilterTools.availabilityFiltered.today = false;
                    availabilityFilterTools.availabilityFiltered.week = false;
                    availabilityFilterTools.availabilitySplice.today = [];
                    availabilityFilterTools.availabilitySplice.week = [];
                    availabilityFilterTools.unavailList.today = [];
                    availabilityFilterTools.unavailList.week = [];
                    availabilityFilterTools.initialLength = 0;
                    availabilityFilterTools.filteredLength = 0;
                    availabilityFilterTools.adjustmentLength = 0;
                    availabilityFilterTools.updateAvailabilityFilter(store.products);
                    watchStockComplete.value = false;
                }
            })

            Vue.watch(vehicleSearch.vehicles, (newValue) => {
                pageInitiated.value = false;
                collectionConfig.cursor = ''
                collectionConfig.hasNextPage = true
                newProdSearch()
            })

            Vue.watch(checkedInputs, (newValue) => {
                checkedSource.value = true;
                collectionConfig.pageFilters = newValue;
                collectionConfig.cursor = ''
                collectionConfig.hasNextPage = true;
                if (listening.value) {
                    setTimeout(newProdSearch, 1500)
                }
                listening.value = false
            })

            const fitmentStore = window.fitmentStore ? window.fitmentStore() : null
            const selectedFitment = Vue.ref(fitmentStore?.selectedFitment || null)
            if (fitmentStore) {
                Vue.watch(
                    () => fitmentStore.selectedFitment,
                    (val) => {
                        selectedFitment.value = val || null
                    },
                    { immediate: true }
                )
            }
            Vue.watch(selectedFitment, () => {
                if (pageInitiated.value) {
                    collectionConfig.cursor = ''
                    collectionConfig.hasNextPage = true
                    newProdSearch()
                }
            })

            if (isBestseller) {
                Vue.watch(
                    () => storeSelector?.nearestStore,
                    async (newStore) => {
                        if (newStore && store.products?.edges?.length) {
                            await checkSplits();
                            if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                        }
                    }
                )
            }

            const activePickerId = Vue.ref(null)
            const pickerQuantities = Vue.reactive({})

            const splitQuantities = Vue.reactive({})

            const getActiveVehicle = () => {
                const selectedVehicle = getSelectedVehicleForSelection()
                if (selectedVehicle) return selectedVehicle
                return null
            }

            const getCollectionProductType = () => {
                if (wheelCollection) { return 'wheel' } else { return 'tyre' }
            }

            const getFitmentLabel = (fitment) => {
                return fitment?.full_desc || fitment?.desc || fitment?.display_name || ''
            }

            const getActiveFitment = () => {
                const vehicle = getActiveVehicle()
                if (!vehicle) return null
                const productType = getCollectionProductType()

                if (selectedFitment.value) {
                    const frontLabel = selectedFitment.value.fullSize || selectedFitment.value.size || ''
                    const rearLabel = selectedFitment.value.fullRearSize || selectedFitment.value.rearSize || ''
                    if (selectedFitment.value.isSplit) {
                        return {
                            isSplit: true,
                            front: frontLabel,
                            rear: rearLabel
                        }
                    }
                    return {
                        isSplit: false,
                        single: frontLabel
                    }
                }

                const tyreFitment = vehicle.fitmentInfo?.tyre_fitments?.[0] || null
                const wheelFitment = vehicle.fitmentInfo?.wheel_fitments?.[0] || null

                const preferredFitment = productType === 'wheel' ? (wheelFitment || tyreFitment) : (tyreFitment || wheelFitment)
                if (!preferredFitment) return null

                const isWheelFitment = preferredFitment === wheelFitment
                const frontNode = isWheelFitment ? preferredFitment.f_wheels : preferredFitment.f_tyres
                const rearNode = isWheelFitment ? preferredFitment.r_wheels : preferredFitment.r_tyres

                if (preferredFitment.is_split) {
                    return {
                        isSplit: true,
                        front: getFitmentLabel(frontNode),
                        rear: getFitmentLabel(rearNode)
                    }
                }
                return {
                    isSplit: false,
                    single: getFitmentLabel(frontNode)
                }


            }

            const isVehicleSplit = () => {
                const fitment = getActiveFitment()
                return !!fitment?.isSplit
            }

            const getVariantId = (variantId) => {
                if (!variantId) return null
                if (typeof variantId === 'string' && variantId.includes('/')) {
                    return variantId.split('/').pop()
                }
                return variantId
            }

            const cartToolsStore = window.cartTools();


            const getCartId = (cartTools) => {
                if (!cartTools) return null
                const cartData = cartTools.cartData?.value || cartTools.cartData || null
                if (cartData?.id) return cartData.id
                try {
                    const raw = localStorage.getItem('cartData')
                    const parsed = raw ? JSON.parse(raw) : null
                    return parsed?.id || null
                } catch (e) { }
                return null
            }

            const isTyreProduct = (productNode) => {
                const typeStr = String(productNode?.productType || productNode?.type || productNode?.category?.name || '').toLowerCase()
                return typeStr.includes('tyre') || typeStr.includes('tire')
            }

            const addVariantToCart = async (variantId, qty, promo, productNode) => {
                if (!cartToolsStore || !variantId || !qty) return
                const isTyre = productNode ? isTyreProduct(productNode) : false
                const cartId = getCartId(cartToolsStore)
                try {
                    if (cartId) {
                        await cartToolsStore.cartAdd(variantId, qty, cartId, promo, isTyre)
                    } else {
                        await cartToolsStore.newCart(variantId, qty, vehicleSearch.vehicles, storeSelector.location, promo, isTyre)
                    }
                } catch (e) {
                    await cartToolsStore.newCart(variantId, qty, vehicleSearch.vehicles, storeSelector.location, promo, isTyre)
                }
                cartToolsStore.openCheckout = false
                cartToolsStore.showCart = true
            }
            const ensurePickerQty = (productNode) => {
                const key = productNode?.id
                if (!key) return null
                if (!pickerQuantities[key]) {
                    const flip = productNode?.stock?.flip
                    let defaultQty = 4
                    if (Array.isArray(flip) && flip.length > 0) {
                        for (let i = Math.min(3, flip.length - 1); i >= 0; i--) {
                            if (getFlipSlotStatus(productNode, i) === 'nearest') {
                                defaultQty = i + 1
                                break
                            }
                        }
                    }
                    pickerQuantities[key] = defaultQty
                }
                return pickerQuantities[key]
            }

            const getPickerQty = (productNode) => {
                return ensurePickerQty(productNode) || 1
            }

            const setPickerQty = (productNode, qty) => {
                const key = productNode?.id
                if (!key) return
                pickerQuantities[key] = qty
            }

            const goToEnquiryPage = () => {
                const url = (typeof window.getEnquiryPageUrl === 'function')
                    ? window.getEnquiryPageUrl()
                    : `${String(shopifyConfig?.storeURL || window.location.origin || '').replace(/\/$/, '')}/pages/contact`
                window.location.href = url
            }

            const openQuantityPicker = (productNode) => {
                if (!productNode?.id) return
                if (getStockStatus(productNode) === 'out') {
                    const flip = productNode?.stock?.flip
                    const hasFlipAvailability = Array.isArray(flip) && flip.some((_, idx) => {
                        const slotStatus = getFlipSlotStatus(productNode, idx)
                        return slotStatus === 'nearest' || slotStatus === 'nearby'
                    })
                    if (!hasFlipAvailability) {
                        goToEnquiryPage()
                        return
                    }
                }
                ensurePickerQty(productNode)
                activePickerId.value = productNode.id
            }

            const closeQuantityPicker = () => {
                activePickerId.value = null
            }

            const isPickerOpen = (productNode) => {
                if (!productNode?.id) return false
                return activePickerId.value === productNode.id
            }

            const ensureSplitQty = (productNode) => {
                const key = productNode?.id
                if (!key) return null
                if (!splitQuantities[key]) {
                    splitQuantities[key] = { front: 2, rear: 2 }
                }
                return splitQuantities[key]
            }

            const getSplitQty = (productNode, axle) => {
                const entry = ensureSplitQty(productNode)
                if (!entry) return 0
                return axle === 'rear' ? entry.rear : entry.front
            }

            const updateSplitQty = async (productNode, axle, delta) => {
                const entry = ensureSplitQty(productNode)
                if (!entry) return
                const current = axle === 'rear' ? entry.rear : entry.front
                const nextValue = Math.max(0, current + delta)
                let nearbyLocations = [];
                if (localStorage.getItem('storesUnder100')) {
                    try {
                        let parsedStores = JSON.parse(localStorage.getItem('storesUnder100'));
                        nearbyLocations = nearbyLocations.concat(parsedStores);
                    } catch (err) {
                        console.error(`Error retrieving nearby stores: ${err}`)
                    }
                }
                let requestLocations = nearbyLocations.flatMap(location => {
                    if (location?.node?.id && typeof location?.node?.id != 'undefined') return location?.node?.id?.replaceAll("gid://shopify/Location/", "");
                    return [];
                });
                if (storeSelector?.nearestStore?.node?.id) requestLocations?.unshift(storeSelector?.nearestStore?.node?.id?.replaceAll("gid://shopify/Location/", ""))
                if (axle === 'rear') {
                    entry.rear = nextValue
                    if (nextValue > 0 && requestLocations?.length > 0) {
                        if (productNode?.splitProduct?.node?.id) {
                            let stockUpdate = await stock.requestStock([productNode.splitProduct.node.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
                            const locStock = stockUpdate?.[0]?.locations?.[0];
                            productNode.splitProduct.node.stock.leadDays = locStock?.availableDays;
                            productNode.splitProduct.node.stock.available = locStock?.available;
                        } else if (productNode?.id) {
                            let stockUpdate = await stock.requestStock([productNode.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
                            const locStock = stockUpdate?.[0]?.locations?.[0];
                            productNode.stock.leadDays = locStock?.availableDays;
                            productNode.stock.available = locStock?.available;
                        }
                    }
                } else {
                    entry.front = nextValue
                    if (nextValue > 0 && requestLocations?.length > 0) {
                        let stockUpdate = await stock.requestStock([productNode.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
                        const locStock = stockUpdate?.[0]?.locations?.[0];
                        productNode.stock.leadDays = locStock?.availableDays;
                        productNode.stock.available = locStock?.available;
                    }
                }
            }

            const splitFitmentDisplay = (productNode) => {
                const fitment = getActiveFitment()
                if (!fitment?.isSplit) return null
                if (!productNode?.is_split || !productNode?.splitProduct?.node) return null

                const basePrice = productNode?.priceRange?.minVariantPrice?.amount
                const splitPrice = productNode?.splitProduct?.node?.priceRange?.minVariantPrice?.amount

                let frontPrice = basePrice
                let rearPrice = splitPrice
                if (productNode?.fits === 'REAR') {
                    frontPrice = splitPrice
                    rearPrice = basePrice
                }

                if (wheelCollection && vehicleSearch.vehicles.length > 0) {
                    if (vehicleSearch?.vehicles[0]?.fitmentInfo?.wheel_fitments[0]?.f_wheels?.desc) {
                        fitment.front = vehicleSearch.vehicles[0].fitmentInfo.wheel_fitments[0].f_wheels.desc
                    }

                    if (vehicleSearch?.vehicles[0]?.fitmentInfo?.wheel_fitments[0]?.r_wheels?.desc) {
                        fitment.rear = vehicleSearch.vehicles[0].fitmentInfo.wheel_fitments[0].r_wheels.desc
                    }
                }

                return {
                    frontSize: fitment.front,
                    rearSize: fitment.rear,
                    frontPrice: promoStore.priceFormat(frontPrice),
                    rearPrice: promoStore.priceFormat(rearPrice),
                    rearAvailable: true
                }
            }

            const fitmentDisplay = (productNode) => {
                const fitment = getActiveFitment()
                if (!fitment) {
                    return {
                        frontSize: '',
                        rearSize: '',
                        frontPrice: '',
                        rearPrice: ''
                    }
                }

                if (wheelCollection && vehicleSearch.vehicles.length > 0) {
                    if (vehicleSearch?.vehicles[0]?.fitmentInfo?.wheel_fitments[0]?.f_wheels?.desc) {
                        fitment.front = vehicleSearch.vehicles[0].fitmentInfo.wheel_fitments[0].f_wheels.desc
                    }

                    if (vehicleSearch?.vehicles[0]?.fitmentInfo?.wheel_fitments[0]?.r_wheels?.desc) {
                        fitment.rear = vehicleSearch.vehicles[0].fitmentInfo.wheel_fitments[0].r_wheels.desc
                    }
                }

                if (fitment.isSplit) {
                    if (productNode?.is_split && productNode?.splitProduct?.node) {
                        return splitFitmentDisplay(productNode)
                    }
                    const basePrice = productNode?.priceRange?.minVariantPrice?.amount
                    if (productNode?.fits === 'REAR') {
                        return {
                            frontSize: fitment.front || '',
                            rearSize: fitment.rear || '',
                            frontPrice: 'Not available',
                            rearPrice: promoStore.priceFormat(basePrice),
                            rearAvailable: true
                        }
                    }
                    return {
                        frontSize: fitment.front || '',
                        rearSize: fitment.rear || '',
                        frontPrice: promoStore.priceFormat(basePrice),
                        rearPrice: '',
                        rearAvailable: false
                    }
                }

                const basePrice = productNode?.priceRange?.minVariantPrice?.amount
                return {
                    frontSize: fitment.single || '',
                    rearSize: '',
                    frontPrice: promoStore.priceFormat(basePrice),
                    rearPrice: '',
                    rearAvailable: false
                }
            }

            const addToCart = async (productNode) => {
                if (!productNode) return
                if (getStockStatus(productNode) === 'out') {
                    goToEnquiryPage()
                    return
                }
                const fitmentDisplay = splitFitmentDisplay(productNode)
                let basePromo = false;
                if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
                    if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                        basePromo = true;
                    }
                }
                if (fitmentDisplay) {
                    const frontQty = getSplitQty(productNode, 'front')
                    const rearQty = getSplitQty(productNode, 'rear')
                    const baseVariantId = getVariantId(productNode?.variants?.edges?.[0]?.node?.id)
                    const splitVariantId = getVariantId(productNode?.splitProduct?.node?.variants?.edges?.[0]?.node?.id)
                    let splitPromo = false;
                    if (productNode?.splitProduct?.node?.collections?.edges?.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
                        if (productNode?.splitProduct?.node?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                            splitPromo = true;
                        }
                    }
                    if (productNode?.fits === 'REAR') {
                        if (splitVariantId && frontQty > 0) await addVariantToCart(splitVariantId, frontQty, splitPromo, productNode)
                        if (baseVariantId && rearQty > 0) await addVariantToCart(baseVariantId, rearQty, basePromo, productNode)
                    } else {
                        if (baseVariantId && frontQty > 0) await addVariantToCart(baseVariantId, frontQty, basePromo, productNode)
                        if (splitVariantId && rearQty > 0) await addVariantToCart(splitVariantId, rearQty, splitPromo, productNode)
                    }
                    return
                }
                const variantId = getVariantId(productNode?.variants?.edges?.[0]?.node?.id)
                if (variantId) {
                    await addVariantToCart(variantId, 1, basePromo, productNode)
                }
            }

            const addToCartWithQty = async (productNode) => {
                if (!productNode) return
                closeQuantityPicker()
                setCartAdding(productNode)
                const fitmentDisplayResult = splitFitmentDisplay(productNode)
                if (fitmentDisplayResult) {
                    try {
                        await addToCart(productNode)
                        setCartSuccess(productNode)
                    } catch (e) {
                        setCartIdle()
                    }
                    return
                }
                const qty = getPickerQty(productNode)
                if (getFlipSlotStatus(productNode, qty - 1) === 'none') {
                    setCartIdle()
                    return
                }
                const variantId = getVariantId(productNode?.variants?.edges[0]?.node?.id)
                let basePromo = false
                if (productNode?.collections.edges.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
                    if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                        basePromo = true
                    }
                }
                try {
                    if (variantId) {
                        await addVariantToCart(variantId, qty, basePromo, productNode)
                        setCartSuccess(productNode)
                    } else {
                        setCartIdle()
                    }
                } catch (e) {
                    setCartIdle()
                }
            }

            const getSkuFromTags = (node) => {
                const tags = node?.tags
                if (!Array.isArray(tags)) return ''
                const skuTag = tags.find(tag => typeof tag === 'string' && /^sku:/i.test(tag))
                return skuTag ? skuTag.replace(/^sku:/i, '').trim() : ''
            }

            const getSkuFromNode = (node) => {
                const tagSku = getSkuFromTags(node)
                if (tagSku) return tagSku
                const variantSku = node?.variants?.edges?.[0]?.node?.sku
                if (typeof variantSku === 'string' && variantSku.trim()) return variantSku.trim()
                return ''
            }

            const splitSkuDisplay = (productNode) => {
                const baseSku = getSkuFromNode(productNode)
                const splitNode = productNode?.splitProduct?.node || null

                if (!productNode?.is_split || !splitNode) {
                    if (productNode?.fits === 'REAR') {
                        return { frontSku: '', rearSku: baseSku }
                    }
                    return { frontSku: baseSku, rearSku: '' }
                }

                const splitSku = getSkuFromNode(splitNode)
                if (productNode.fits === 'REAR') {
                    return { frontSku: splitSku, rearSku: baseSku }
                }
                return { frontSku: baseSku, rearSku: splitSku }
            }



            const getLabelTags = (productNode) => {
                const tags = productNode?.tags
                if (!Array.isArray(tags)) return []
                return tags
                    .filter((tag) => typeof tag === 'string' && /^label\s*:/i.test(tag))
                    .map((tag) => tag.replace(/^label\s*:\s*/i, '').trim())
                    .filter(Boolean)
            }

            const getProductTitleFromTags = (productNode) => {
                const tags = productNode?.tags
                if (!Array.isArray(tags)) return productNode?.title || ''
                const tag = tags.find((t) => typeof t === 'string' && /^product\s*:/i.test(t))
                if (!tag) return productNode?.title || ''
                return tag.replace(/^product\s*:\s*/i, '').trim()
            }

            const splitWheelTitle = (productNode) => {
                const tags = productNode?.tags
                if (!Array.isArray(tags)) return productNode?.title || ''
                const tag = tags.find((t) => typeof t === 'string' && /^product\s*:/i.test(t)).replace(/^product\s*:\s*/i, '').trim()
                if (!tag) return productNode?.title || ''
                return [tag, productNode.title.replaceAll(tag, '').trim()]
            }

            const isStockLoading = (productNode) => {
                const stock = productNode?.stock;
                if (!stock || typeof stock !== 'object' || Array.isArray(stock)) return true;
                if (stock.available == null) return true;
                return false;
            };

            const getNearestStore = () => {
                try {
                    const storeSelector = window.storeSelector ? window.storeSelector() : null
                    return storeSelector?.nearestStore || null
                } catch (e) { }
                try {
                    const raw = localStorage.getItem('currentNearestStore')
                    return raw ? JSON.parse(raw) : null
                } catch (e) { }
                return null
            }

            const getNearestStoreName = () => {
                const store = getNearestStore()
                const node = store?.node || store
                return node?.name || 'selected store'
            }

            const hasNearestStore = () => {
                return !!getNearestStore()
            }

            const openStoreSelector = () => {
                const button = document.getElementById('my-store-btn')
                if (button) {
                    document.body.classList.remove('gg-header-collapsed');
                    const stickyHeader = document.getElementById('stickyHeader');
                    if (stickyHeader) stickyHeader.classList.remove('header-collapsed');
                    button.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    button.click()
                }
            }

            const getSplitStockStatus = (productNode, axle) => {
                if (!productNode) return 'loading';
                const isRear = axle === 'rear';
                const splitNode = productNode?.splitProduct?.node || null;

                if (!splitNode) {
                    const baseStatus = getStockStatus(productNode);
                    if (productNode?.fits === 'REAR') {
                        return isRear ? baseStatus : 'out';
                    }
                    return isRear ? 'out' : baseStatus;
                }

                const frontNode = productNode?.fits === 'REAR' ? splitNode : productNode;
                const rearNode = productNode?.fits === 'REAR' ? productNode : splitNode;
                const targetNode = isRear ? rearNode : frontNode;
                return getStockStatus(targetNode);
            };

            const getSplitNodeByAxle = (productNode, axle) => {
                if (!productNode) return null;
                const isRear = axle === 'rear';
                const splitNode = productNode?.splitProduct?.node || null;

                if (!splitNode) {
                    if (productNode?.fits === 'REAR') {
                        return isRear ? productNode : null;
                    }
                    return isRear ? null : productNode;
                }

                const frontNode = productNode?.fits === 'REAR' ? splitNode : productNode;
                const rearNode = productNode?.fits === 'REAR' ? productNode : splitNode;
                return isRear ? rearNode : frontNode;
            };

            const getSplitStock = (productNode, axle) => {
                return getSplitNodeByAxle(productNode, axle)?.stock || null;
            };

            const getStockStatus = (productNode) => {
                const stock = productNode?.stock;
                if (!stock || typeof stock !== 'object' || Array.isArray(stock)) return 'loading';
                if (stock.available === 'ERROR') return 'error';
                if (stock.available == null) return 'loading';
                const available = String(stock.available).trim().toUpperCase();
                if (available === 'Y' || available === 'L' || stock.available === true) return 'in';
                if (available === 'N' || stock.available === false) return 'out';
                return 'loading';
            };

            const getFlipSlotNearbyStoreName = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return 'a nearby store';
                const locationGid = flip[slotIndex]?.nearestStore;
                if (!locationGid) return 'a nearby store';

                try {
                    const stores = JSON.parse(localStorage.getItem('storesUnder100') || '[]');
                    const match = stores.find(s => {
                        const id = String(s?.node?.id || '').replace('gid://shopify/Location/', '');
                        return id === String(locationGid);
                    });
                    if (match?.node?.name) return match.node.name;
                } catch (e) { }

                return 'a nearby store';
            };

            const vehicleName = Vue.computed(() => {
                const selectedVehicle = getSelectedVehicleForSelection()
                return selectedVehicle?.make?.display_name && selectedVehicle?.model?.display_name
                    ? `${selectedVehicle.make.display_name} ${selectedVehicle.model.display_name}`
                    : false
            })

            const vehicleMakeName = Vue.computed(() => {
                const selectedVehicle = getSelectedVehicleForSelection()
                return selectedVehicle?.make?.display_name
                    ? `${selectedVehicle.make.display_name}`
                    : false
            })

            const vehicleLogo = Vue.computed(() => getSelectedVehicleForSelection()?.logo_url || null)

            const productsExist = Vue.computed(() => {
                return products?.value?.edges?.length > 0 ? true : false
            })


            const sendEnquiry = (node, split) => {
                if (split) {
                    localStorage.setItem('storeEnquiry', JSON.stringify(
                        {
                            title: node.title || "",
                            sku: node.tags.filter(tag => tag.includes('sku:'))[0].replaceAll('sku:', '') || "",
                            splitTitle: split.title || "",
                            splitSku: split.tags.filter(tag => tag.includes('sku:'))[0].replaceAll('sku:', '') || ""
                        }
                    ))
                } else {
                    localStorage.setItem('storeEnquiry', JSON.stringify(
                        {
                            title: node.title || "",
                            sku: node.tags.filter(tag => tag.includes('sku:'))[0].replaceAll('sku:', '') || ""
                        }
                    ))
                }

                const existingIndex = (compareStore.selectedProducts || []).findIndex(p =>
                    normalizeCompareId(p.id || p.node?.id) === normalizeCompareId(node.id)
                );

                if (existingIndex == -1) {
                    if (compareStore.selectedProducts.length >= 3) {
                        compareStore.selectedProducts.splice(0, 1);
                    }

                    // Add product to store
                    compareStore.selectedProducts.push({
                        id: node.id,
                        title: node.title,
                        handle: node.handle || null,
                        price: node.priceRange.minVariantPrice.amount,
                        featured_image: node.images?.edges[0]?.node?.url || defaultTyreImage,
                        vendor: node.vendor,
                        available: node.availableForSale
                    });
                    compareStore.persist();
                }
                setCartEnquiring(node)
                window.location.href = `${shopifyConfig.storeURL}/pages/${shopifyConfig.contactDefault}`;
            };

            const setCartAdding = (productNode) => {
                cartAddingId.value = productNode?.id || null
                cartSuccessId.value = null
            }

            const setCartSuccess = (productNode) => {
                cartAddingId.value = null
                cartSuccessId.value = productNode?.id || null
                if (cartSuccessTimer) clearTimeout(cartSuccessTimer)
                cartSuccessTimer = setTimeout(() => {
                    cartSuccessId.value = null
                }, 2500)
            }

            const setCartIdle = () => {
                cartAddingId.value = null
                cartSuccessId.value = null
            }

            const isCartAdding = (productNode) => cartAddingId.value === productNode?.id
            const isCartSuccess = (productNode) => cartSuccessId.value === productNode?.id


            const setCartEnquiring = (productNode) => {
                cartEnquiringId.value = productNode?.id || null
            }
            const isCartEnquiring = (productNode) => cartEnquiringId.value === productNode?.id

            const getProductUrl = (productNode) => {
                const base = `/products/${productNode.handle}`
                if (!productNode?.is_split || !productNode?.splitProduct?.node) {
                    if (productNode?.fits === 'REAR' && productNode?.handle) {
                        const rearHandle = encodeURIComponent(productNode.handle)
                        return `/products/${productNode.handle}?r=${rearHandle}`
                    }
                    if (productNode?.fits === 'FRONT' && productNode?.handle) {
                        const frontHandle = encodeURIComponent(productNode.handle)
                        return `/products/${productNode.handle}?f=${frontHandle}&r=none`
                    }
                    return base
                }

                const frontNode = getSplitNodeByAxle(productNode, 'front')
                const rearNode = getSplitNodeByAxle(productNode, 'rear')

                if (!frontNode?.handle) return base
                const frontHandle = encodeURIComponent(frontNode.handle)
                if (!rearNode?.handle) return `/products/${frontNode.handle}?f=${frontHandle}&r=none`

                const rearHandle = encodeURIComponent(rearNode.handle)
                return `/products/${frontNode.handle}?f=${frontHandle}&r=${rearHandle}`
            }

            const availabilityString = (node) => {
                if (!node?.stock?.leadDays) return 'Available'
                if (node?.stock?.leadDays === 0) {
                    return 'Available Now'
                } else if (node?.stock?.leadDays === 1) {
                    return 'Get it Tomorrow';
                } else if (node?.stock?.leadDays < 7) {
                    let parsedLead = Date.parse(new Date()) + node?.stock?.leadDays * 24 * 60 * 60 * 1000;
                    let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' })
                    if (day == 'Sunday') {
                        return 'Get it by Monday'
                    }
                    return `Get it by ${day}`;
                } else {
                    return `Get it in ${node?.stock?.leadDays} days`;
                }
            }

            const wheelAvailabilityString = (node) => {
                let response = {}
                if (node?.stock?.genericStorage) {
                    response.line1 = 'Available at Supplier';
                    if (!node?.stock?.leadDays) return response;
                    if (node?.stock?.leadDays === 0) response.line2 = `ETA: Today at ${getNearestStoreName()}`
                    else if (node?.stock?.leadDays === 1) response.line2 = `ETA: Tomorrow at ${getNearestStoreName()}`
                    else if (node?.stock?.leadDays < 7) {
                        let parsedLead = Date.parse(new Date()) + node?.stock?.leadDays * 24 * 60 * 60 * 1000;
                        let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' });
                        if (day == 'Sunday') response.line2 = `ETA: Monday at ${getNearestStoreName()}`
                        else response.line2 = `ETA: ${day} at ${getNearestStoreName()}`
                    } else response.line2 = `ETA: ${node?.stock?.leadDays} days at ${getNearestStoreName()}`
                    return response;
                } else {
                    response.line1 = ""
                    if (!node?.stock?.leadDays) response.line1 = `Available at ${getNearestStoreName()}`
                    else if (node?.stock?.leadDays === 0) response.line1 = `Available Now at ${getNearestStoreName()}`
                    else if (node?.stock?.leadDays === 1) response.line1 = `Get it Tomorrow at ${getNearestStoreName()}`;
                    else if (node?.stock?.leadDays < 7) {
                        let parsedLead = Date.parse(new Date()) + node?.stock?.leadDays * 24 * 60 * 60 * 1000;
                        let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' })
                        if (day == 'Sunday') response.line1 = `Get it by Monday at ${getNearestStoreName()}`
                        else response.line1 = `Get it by ${day} at ${getNearestStoreName()}`;
                    } else response.line1 = `Get it in ${node?.stock?.leadDays} days at ${getNearestStoreName()}`;
                }
                return response;
            }

            const storeLink = (storeName) => {
                return `${shopifyConfig.storeURL}/pages/${storeName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`
            }

            const isLoading = Vue.computed(() => showProduct.value);
            const isEmpty = Vue.computed(() => !productsExist.value && !isLoading.value);

            const toggleSortUtility = () => {
                showSortUtility.value = !showSortUtility.value;
            }


            return {
                collectionConfig,
                products,
                filters,
                sortSelector,
                showProduct,
                showFilters,
                isPlpRefreshing,
                isLoading,
                isEmpty,
                checkedInputs,
                toggleCompare,
                closeHover,
                resetHover,
                isCompareModalOpen,
                canCompare,
                openCompareModal,
                closeCompareModal,
                totalCompare,
                clearAll,
                clearAllFilters,
                clearVehicleAndSeeAllTyres,
                removeFromCompare,
                closeDrawer,
                store,
                compareStore: compareRef,
                isFilterDrawerOpen,
                openFilterDrawer,
                closeFilterDrawer,
                toggleFilterDrawer,
                displayedFilterValues,
                toggleFilterExpansion,
                isFilterExpanded,
                quickFilters,
                toggleQuickFilter,
                isQuickFilterActive,
                splitFitmentDisplay,
                fitmentDisplay,
                isVehicleSplit,
                getSplitQty,
                updateSplitQty,
                addToCart,
                openQuantityPicker,
                closeQuantityPicker,
                isPickerOpen,
                getPickerQty,
                setPickerQty,
                addToCartWithQty,
                getLabelTags,
                getProductTitleFromTags,
                isStockLoading,
                getNearestStoreName,
                hasNearestStore,
                openStoreSelector,
                getSplitStockStatus,
                getSplitNodeByAxle,
                getSplitStock,
                getStockStatus,
                isInCompare,
                promoStore,
                defaultTyreImage,
                vehicleSearch,
                vehicleName,
                vehicleMakeName,
                vehicleLogo,
                productsExist,
                wheelCollection,
                getFlipSlotAvailable,
                getFlipSlotLeadTime,
                getFlipSlotPrice,
                getFlipSlotStatus,
                getFlipSlotNearbyStoreName,
                splitWheelTitle,
                sendEnquiry,
                isCartAdding,
                isCartSuccess,
                isCartEnquiring,
                splitSkuDisplay,
                getProductUrl,
                checkedLoad,
                showLoadMoreBtn,
                loadMore,
                isLoadingMore,
                availabilityString,
                wheelAvailabilityString,
                getCollectionProductType,
                storeLink,
                availabilityFilterTools,
                showSortUtility,
                toggleSortUtility
            };
        }
    })
    PLP.use(window.VueAppGlobals.pinia);
    PLP.mount(mountSelector);
}

if (typeof plpMounted === 'undefined') var plpMounted = false;

function GGbootstrap() {
    const plpEl = document.querySelector('#PLP');
    const bestsellerEls = Array.from(document.querySelectorAll('[id^="bestseller-vue-"]'));

    if (plpEl && !plpMounted) {
        plpMounted = true;
        vuePLP('#PLP');
    }

    if (bestsellerEls.length > 0) {
        const bsMounted = {};
        const mountBestsellers = () => {
            bestsellerEls.forEach(el => {
                if (bsMounted[el.id]) return;
                bsMounted[el.id] = true;
                vuePLP(`#${el.id}`);
            });
        };

        if (plpEl) {
            const store = window.collectionStore();
            store.setBestsellerRefresh(mountBestsellers);
            Vue.watch(
                () => store.showNoProdSection,
                (show) => {
                    const section = document.querySelector('[id^="topSellingSection-"]');
                    if (!section) return;
                    section.style.display = show ? 'block' : 'none';
                    if (show) mountBestsellers();
                }
            );
        } else {
            // No PLP on this page — mount bestseller sections immediately.
            mountBestsellers();
        }
    }
}

if (typeof GGcollectionInit === 'undefined') {
    window.GGcollectionInit = true;
    if (window.Vue && window.Pinia) {
        GGbootstrap();
    } else {
        window.addEventListener('vue-ready', GGbootstrap);
    }
}
